"use client";
var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/components/button/index.tsx
import React from "react";
import { Slot } from "@radix-ui/react-slot";
import { button } from "@pinatagrams/design-system/recipes";
import { motion } from "motion/react";
import { useCallback } from "react";

// src/components/button/motion.ts
import { DURATION, OPACITY } from "@pinatagrams/design-system";
var variants = {
  bold: {
    disabled: {
      opacity: OPACITY.disabled
    },
    rest: {
      y: "0"
    },
    rise: {
      y: "-.25rem"
    },
    active: {
      y: "-.25rem",
      transition: {
        duration: DURATION.rapid
      }
    },
    focus: {
      y: "-.25rem",
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.5)"
    }
  },
  subtle: {
    disabled: {
      opacity: OPACITY.disabled
    },
    focus: {
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.5)"
    }
  },
  DEFAULT: {
    disabled: {
      opacity: OPACITY.disabled
    },
    focus: {
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.5)"
    }
  },
  ghost: {
    disabled: {
      opacity: OPACITY.disabled
    },
    focus: {
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.5)"
    }
  },
  loud: {
    disabled: {
      opacity: OPACITY.disabled
    },
    rest: {
      scaleX: "100%",
      scaleY: "100%"
    },
    rise: {
      scaleX: "110%",
      scaleY: "90%"
    },
    focus: {
      boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.5)"
    }
  }
};

// src/components/button/sound/click.mp3
var click_default = "data:audio/mpeg;base64,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";

// src/components/button/sound/release.mp3
var release_default = "data:audio/mpeg;base64,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";

// src/components/button/index.tsx
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var MotionSlot = motion(Slot);
var Button = React.forwardRef(
  ({ emphasis, children, size = "md", icons, disabled, asChild, className, style, ...props }, ref) => {
    const { onBlur, onFocus, onMouseDown, onMouseUp } = props;
    const buttonClassName = button({ emphasis, size });
    const mergedClassName = className ? `${buttonClassName} ${className}` : buttonClassName;
    const buttonRef = React.useRef(null);
    const audioRef = React.useRef(null);
    const LeftIcon = icons?.[0];
    const RightIcon = icons?.[1];
    const setRefs = useCallback(
      (node) => {
        buttonRef.current = node;
        if (typeof ref === "function") {
          ref(node);
        } else if (ref) {
          ref.current = node;
        }
      },
      [ref]
    );
    const audioButtonPress = useCallback((state) => {
      audioRef.current = new Audio(state === "click" ? click_default : release_default);
      const playPromise = audioRef.current.play();
      if (playPromise instanceof Promise) {
        playPromise.catch((error) => {
          console.error("Error playing audio:", error);
        });
      }
    }, []);
    const handleOnMouseDown = useCallback(
      (event) => {
        onMouseDown?.(event);
        audioButtonPress("click");
      },
      [onMouseDown, audioButtonPress]
    );
    const handleOnMouseUp = useCallback(
      (event) => {
        onMouseUp?.(event);
        audioButtonPress("release");
      },
      [onMouseUp, audioButtonPress]
    );
    const handleOnFocus = useCallback(
      (event) => {
        onFocus?.(event);
      },
      [onFocus]
    );
    const handleOnBlur = useCallback(
      (event) => {
        onBlur?.(event);
      },
      [onBlur]
    );
    const Component = asChild ? MotionSlot : motion.button;
    const content = asChild ? children : /* @__PURE__ */ jsxs(Fragment, { children: [
      LeftIcon && /* @__PURE__ */ jsx(LeftIcon, {}),
      children,
      RightIcon && /* @__PURE__ */ jsx(RightIcon, {})
    ] });
    return /* @__PURE__ */ jsx(
      Component,
      {
        ref: setRefs,
        className: mergedClassName,
        style,
        transition: {
          duration: 0.2,
          ease: "linear"
        },
        variants: variants[emphasis] || variants["DEFAULT"],
        initial: "rest",
        animate: disabled ? "disabled" : "rest",
        whileHover: "rise",
        whileTap: "active",
        whileFocus: "focus",
        layout: "position",
        onMouseDown: handleOnMouseDown,
        onMouseUp: handleOnMouseUp,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        disabled: asChild ? void 0 : disabled,
        ...props,
        children: content
      }
    );
  }
);
Button.displayName = "Button";
var button_default = Button;

// src/components/label/index.tsx
import React2 from "react";
import { label } from "@pinatagrams/design-system/recipes";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var LabelRoot = React2.forwardRef(
  ({ width = 8, height = 4, unit = "in", className, style, children, ...props }, ref) => {
    const customStyle = {
      "--label-width": String(width),
      "--label-height": String(height),
      "--label-unit": `1${unit}`,
      ...style
    };
    return /* @__PURE__ */ jsx2(
      "div",
      {
        ref,
        className: `${label({}).root}${className ? ` ${className}` : ""}`,
        style: customStyle,
        ...props,
        children
      }
    );
  }
);
LabelRoot.displayName = "Label";
var LabelGroup = React2.forwardRef(
  ({ className, children, ...props }, ref) => {
    return /* @__PURE__ */ jsx2("div", { ref, className: `${label({}).group}${className ? ` ${className}` : ""}`, ...props, children });
  }
);
LabelGroup.displayName = "Label.Group";
var LabelDetails = React2.forwardRef(
  ({ className, children, ...props }, ref) => {
    return /* @__PURE__ */ jsx2(
      "div",
      {
        ref,
        className: `${label({}).details}${className ? ` ${className}` : ""}`,
        ...props,
        children
      }
    );
  }
);
LabelDetails.displayName = "Label.Details";
var LabelSection = React2.forwardRef(
  ({ variant = "default", className, children, ...props }, ref) => {
    return /* @__PURE__ */ jsx2(
      "section",
      {
        ref,
        className: `${label({ sectionVariant: variant }).section}${className ? ` ${className}` : ""}`,
        ...props,
        children
      }
    );
  }
);
LabelSection.displayName = "Label.Section";
var LabelSku = React2.forwardRef(
  ({ emoji, className, children, ...props }, ref) => {
    return /* @__PURE__ */ jsxs2("h2", { ref, className: `${label({}).sku}${className ? ` ${className}` : ""}`, ...props, children: [
      emoji && /* @__PURE__ */ jsx2("span", { className: label({}).emoji, children: emoji }),
      /* @__PURE__ */ jsx2("span", { children }),
      emoji && /* @__PURE__ */ jsx2("span", { className: label({}).emoji, children: emoji })
    ] });
  }
);
LabelSku.displayName = "Label.Sku";
var LabelPill = React2.forwardRef(
  ({ className, children, ...props }, ref) => {
    return /* @__PURE__ */ jsx2("div", { ref, className: `${label({}).pill}${className ? ` ${className}` : ""}`, ...props, children });
  }
);
LabelPill.displayName = "Label.Pill";
var LabelBulk = React2.forwardRef(
  ({ className, children, ...props }, ref) => {
    return /* @__PURE__ */ jsx2("div", { ref, className: `${label({}).bulk}${className ? ` ${className}` : ""}`, ...props, children });
  }
);
LabelBulk.displayName = "Label.Bulk";
var LabelBulkBox = React2.forwardRef(({ className, children, ...props }, ref) => {
  return /* @__PURE__ */ jsx2(
    "span",
    {
      ref,
      className: `${label({}).bulkBox}${className ? ` ${className}` : ""}`,
      ...props,
      children
    }
  );
});
LabelBulkBox.displayName = "Label.BulkBox";
var LabelDivider = React2.forwardRef(
  ({ highlight = false, className, ...props }, ref) => {
    return /* @__PURE__ */ jsx2(
      "div",
      {
        ref,
        className: `${label({ dividerHighlight: highlight }).divider}${className ? ` ${className}` : ""}`,
        "data-highlight": highlight,
        ...props
      }
    );
  }
);
LabelDivider.displayName = "Label.Divider";
var LabelName = React2.forwardRef(({ className, children, ...props }, ref) => {
  return /* @__PURE__ */ jsx2("h5", { ref, className: `${label({}).name}${className ? ` ${className}` : ""}`, ...props, children });
});
LabelName.displayName = "Label.Name";
var LabelAddress = React2.forwardRef(({ className, children, ...props }, ref) => {
  return /* @__PURE__ */ jsx2("p", { ref, className: `${label({}).address}${className ? ` ${className}` : ""}`, ...props, children });
});
LabelAddress.displayName = "Label.Address";
var LabelMessage = React2.forwardRef(
  ({ className, children, ...props }, ref) => {
    return /* @__PURE__ */ jsx2(
      "pre",
      {
        ref,
        className: `${label({}).message}${className ? ` ${className}` : ""}`,
        ...props,
        children
      }
    );
  }
);
LabelMessage.displayName = "Label.Message";
var LabelId = React2.forwardRef(
  ({ className, children, ...props }, ref) => {
    const dataExternal = props["data-external"] === "true";
    const dataOverdue = props["data-overdue"] === "true";
    return /* @__PURE__ */ jsx2(
      "pre",
      {
        ref,
        className: `${label({ idExternal: dataExternal, idOverdue: dataOverdue }).id}${className ? ` ${className}` : ""}`,
        ...props,
        children
      }
    );
  }
);
LabelId.displayName = "Label.Id";
var LabelGraphic = React2.forwardRef(
  ({ className, alt = "Label graphic", ...props }, ref) => {
    return /* @__PURE__ */ jsx2(
      "img",
      {
        ref,
        className: `${label({}).graphic}${className ? ` ${className}` : ""}`,
        alt,
        loading: "eager",
        ...props
      }
    );
  }
);
LabelGraphic.displayName = "Label.Graphic";
var LabelMessageOverlay = React2.forwardRef(({ className, children, ...props }, ref) => {
  return /* @__PURE__ */ jsx2(
    "div",
    {
      ref,
      className: `${label({}).messageOverlay}${className ? ` ${className}` : ""}`,
      ...props,
      children
    }
  );
});
LabelMessageOverlay.displayName = "Label.MessageOverlay";
var LabelMessageText = React2.forwardRef(({ className, children, style, onChange, onBlur, onFocus, onInput, ...props }, ref) => {
  const messageTextClass = `${label({}).messageText}${className ? ` ${className}` : ""}`;
  const hasCallbacks = Boolean(onChange || onBlur || onFocus || onInput);
  const textareaProps = props;
  if (hasCallbacks) {
    return /* @__PURE__ */ jsx2(
      "textarea",
      {
        ref,
        className: messageTextClass,
        style: {
          ...style
        },
        onChange,
        onBlur,
        onFocus,
        onInput,
        ...textareaProps
      }
    );
  }
  return /* @__PURE__ */ jsx2(
    "div",
    {
      ref,
      className: messageTextClass,
      style,
      ...props,
      children
    }
  );
});
LabelMessageText.displayName = "Label.MessageText";
var Label = Object.assign(LabelRoot, {
  Group: LabelGroup,
  Details: LabelDetails,
  Section: LabelSection,
  Sku: LabelSku,
  Pill: LabelPill,
  Bulk: LabelBulk,
  BulkBox: LabelBulkBox,
  Divider: LabelDivider,
  Name: LabelName,
  Address: LabelAddress,
  Message: LabelMessage,
  Id: LabelId,
  Graphic: LabelGraphic,
  MessageOverlay: LabelMessageOverlay,
  MessageText: LabelMessageText
});
var label_default = Label;

// src/components/tooltip/index.tsx
import React4 from "react";
import { Tooltip as TT } from "radix-ui";
import { tooltip } from "@pinatagrams/design-system/recipes";
import { motion as motion2 } from "motion/react";

// src/contexts/layer-context.tsx
import React3 from "react";

// src/contexts/layer-types.ts
var LayerType = /* @__PURE__ */ ((LayerType2) => {
  LayerType2[LayerType2["Main"] = 0] = "Main";
  LayerType2[LayerType2["Nav"] = 1] = "Nav";
  LayerType2[LayerType2["Popover"] = 2] = "Popover";
  LayerType2[LayerType2["Toasts"] = 3] = "Toasts";
  LayerType2[LayerType2["Overlay"] = 4] = "Overlay";
  return LayerType2;
})(LayerType || {});
var layerNameMap = {
  main: 0 /* Main */,
  nav: 1 /* Nav */,
  popover: 2 /* Popover */,
  toasts: 3 /* Toasts */,
  overlay: 4 /* Overlay */
};

// src/contexts/layer-context.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var LayerContext = React3.createContext(null);
function Wrapper({
  children,
  layer
}) {
  const context = React3.useContext(LayerContext);
  if (!context) {
    throw new Error("[Layer] Layer.Wrapper must be used within Layer");
  }
  const resolvedLayer = typeof layer === "string" ? layerNameMap[layer] : layer;
  const nextLayer = resolvedLayer >= context.layer ? resolvedLayer : context.layer;
  return /* @__PURE__ */ jsx3(LayerContext.Provider, { value: { ...context, layer: nextLayer }, children });
}
function LayerRoot({ children }) {
  const baseLayerStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };
  return /* @__PURE__ */ jsxs3(LayerContext.Provider, { value: { layer: 0 /* Main */ }, children: [
    /* @__PURE__ */ jsx3("style", { children: `
				[data-layer] > * {
					pointer-events: auto;
				}
			` }),
    /* @__PURE__ */ jsx3("section", { id: "layer-popover", style: { ...baseLayerStyle, zIndex: 2 }, "data-layer": "popover" }),
    /* @__PURE__ */ jsx3("section", { id: "layer-toasts", style: { ...baseLayerStyle, zIndex: 3 }, "data-layer": "toasts" }),
    /* @__PURE__ */ jsx3(
      "section",
      {
        id: "layer-overlay",
        style: {
          ...baseLayerStyle,
          zIndex: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        "data-layer": "overlay"
      }
    ),
    children
  ] });
}
function useLayerContainer(overrideLayer) {
  const context = React3.useContext(LayerContext);
  const [container, setContainer] = React3.useState(void 0);
  React3.useLayoutEffect(() => {
    const defaultContainer = document.getElementById("layer-popover");
    if (!defaultContainer) {
      throw new Error("[Layer] Missing default popover layer container");
    }
    if (!context) return setContainer(defaultContainer);
    let targetLayer = context.layer;
    if (overrideLayer !== void 0) {
      targetLayer = overrideLayer >= context.layer ? overrideLayer : context.layer;
    }
    if (targetLayer === 0 /* Main */ || targetLayer === 1 /* Nav */) {
      setContainer(defaultContainer);
      return;
    }
    const layerId = LayerType[targetLayer].toLowerCase();
    const element = document.getElementById(`layer-${layerId}`);
    if (!element) {
      throw new Error(`[Layer] Missing container for layer: ${layerId}`);
    }
    setContainer(element);
  }, [context, overrideLayer]);
  return container;
}
function useLayer() {
  const context = React3.useContext(LayerContext);
  if (!context) {
    throw new Error("[Layer] useLayer must be used within Layer");
  }
  return context.layer;
}
var Layer = Object.assign(LayerRoot, { Wrapper });
var layer_context_default = Layer;

// src/components/tooltip/index.tsx
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var TooltipProvider = ({ children, ...props }) => {
  return /* @__PURE__ */ jsx4(TT.Provider, { ...props, children });
};
var TooltipRoot = ({
  children,
  open,
  onOpenChange,
  delayDuration = 0
}) => {
  const [isOpen, setIsOpen] = React4.useState(open ?? false);
  React4.useEffect(() => {
    if (open !== void 0) {
      setIsOpen(open);
    }
  }, [open]);
  const handleOpenChange = (newOpen) => {
    setIsOpen(newOpen);
    onOpenChange?.(newOpen);
  };
  return /* @__PURE__ */ jsx4(TT.Root, { delayDuration, open: isOpen, onOpenChange: handleOpenChange, children });
};
var TooltipTrigger = ({ children }) => {
  const triggerElement = React4.isValidElement(children) ? children : /* @__PURE__ */ jsx4("span", { children });
  return /* @__PURE__ */ jsx4(TT.Trigger, { asChild: true, children: triggerElement });
};
var TooltipContent = ({
  children,
  side = "top",
  sideOffset = 10,
  cardClassName,
  ...props
}) => {
  const container = useLayerContainer(2 /* Popover */);
  const MotionContent = React4.forwardRef((motionProps, ref) => /* @__PURE__ */ jsx4(motion2.div, { ref, ...motionProps }));
  MotionContent.displayName = "MotionContent";
  return /* @__PURE__ */ jsx4(TT.Portal, { container, children: /* @__PURE__ */ jsx4(TT.Content, { side, sideOffset, ...props, children: /* @__PURE__ */ jsxs4(
    MotionContent,
    {
      className: tooltip().root,
      initial: { opacity: 0, y: 20, scale: 0.8 },
      animate: { opacity: 1, y: 0, scale: 1 },
      exit: {
        opacity: 0,
        y: 20,
        scale: 0.8,
        transition: { duration: 0.1 }
      },
      children: [
        /* @__PURE__ */ jsx4("div", { className: `${tooltip().card}${cardClassName ? ` ${cardClassName}` : ""}`, children }),
        /* @__PURE__ */ jsx4(TT.Arrow, { className: "tooltip-arrow" })
      ]
    }
  ) }) });
};
var Tooltip = Object.assign(TooltipRoot, {
  Trigger: TooltipTrigger,
  Content: TooltipContent,
  Provider: TooltipProvider
});
var tooltip_default = Tooltip;

// src/components/toast/index.tsx
import React9 from "react";
import { motion as motion5, AnimatePresence } from "motion/react";
import { Toast as Toast3, Portal } from "radix-ui";
import { toastRecipe as toastRecipe2 } from "@pinatagrams/design-system/recipes";

// src/components/toast/ToastItem.tsx
import React6 from "react";
import { motion as motion4 } from "motion/react";
import { Toast } from "radix-ui";
import {
  InfoIcon,
  CheckCircleIcon,
  WarningIcon,
  SmileyXEyesIcon,
  CaretRightIcon,
  XCircleIcon
} from "@phosphor-icons/react";
import { SPRING as SPRING2 } from "@pinatagrams/design-system";
import { toastRecipe } from "@pinatagrams/design-system/recipes";

// src/components/layout/index.tsx
import React5 from "react";
import { motion as motion3 } from "motion/react";
import {
  stackLayout,
  rowLayout,
  pageSection,
  pageHeader,
  actionHeader,
  gridLayout,
  mainLayout,
  backdrop,
  scrollContainer
} from "@pinatagrams/design-system/recipes";
import { DURATION as DURATION2, EASING } from "@pinatagrams/design-system";
import { jsx as jsx5 } from "react/jsx-runtime";
var Stack = React5.forwardRef(
  ({ gap = "md", align = "stretch", skeleton = false, className, ...props }, ref) => {
    const { root } = stackLayout({ gap, align, skeleton });
    return /* @__PURE__ */ jsx5("div", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
Stack.displayName = "Stack";
var Inline = React5.forwardRef(
  ({ gap = "md", align = "center", justify = "start", wrap = true, className, ...props }, ref) => {
    const { root } = rowLayout({ gap, align, justify, wrap });
    return /* @__PURE__ */ jsx5("div", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
Inline.displayName = "Inline";
var PageSection = React5.forwardRef(
  ({ maxWidth = "lg", className, ...props }, ref) => {
    const { root } = pageSection({ maxWidth });
    return /* @__PURE__ */ jsx5("section", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
PageSection.displayName = "PageSection";
var PageHeader = React5.forwardRef(
  ({ className, ...props }, ref) => {
    const { root } = pageHeader({});
    return /* @__PURE__ */ jsx5("header", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
PageHeader.displayName = "PageHeader";
var HeaderRoot = React5.forwardRef(
  ({ sticky = false, skeleton = false, className, ...props }, ref) => {
    const { root } = actionHeader({ sticky, skeleton });
    return /* @__PURE__ */ jsx5("header", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
HeaderRoot.displayName = "Header";
var HeaderTitleSection = React5.forwardRef(({ className, ...props }, ref) => {
  const { title } = actionHeader({});
  return /* @__PURE__ */ jsx5("div", { ref, className: `${title}${className ? ` ${className}` : ""}`, ...props });
});
HeaderTitleSection.displayName = "Header.Title";
var HeaderActionsSection = React5.forwardRef(({ className, ...props }, ref) => {
  const { actions } = actionHeader({});
  return /* @__PURE__ */ jsx5("div", { ref, className: `${actions}${className ? ` ${className}` : ""}`, ...props });
});
HeaderActionsSection.displayName = "Header.Actions";
var Header = Object.assign(HeaderRoot, {
  Title: HeaderTitleSection,
  Actions: HeaderActionsSection
});
var Main = React5.forwardRef(
  ({ gap = "lg", padding = "lg", skeleton = false, className, ...props }, ref) => {
    const { root } = mainLayout({ gap, padding, skeleton });
    return /* @__PURE__ */ jsx5("main", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
Main.displayName = "Main";
var Grid = React5.forwardRef(
  ({
    gap = "md",
    justify = "center",
    align = "start",
    items = "center",
    overflow = "auto",
    flex = "fill",
    padding = "lg",
    className,
    ...props
  }, ref) => {
    const { root } = gridLayout({ gap, justify, align, items, overflow, flex, padding });
    return /* @__PURE__ */ jsx5("section", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
  }
);
Grid.displayName = "Grid";
var Overlay = React5.forwardRef(
  ({ status: status2, origin, pos, elevation, size, children, exited }, ref) => {
    const coords = origin || pos;
    const maskType = origin ? "origin" : pos !== void 0 ? "pos" : void 0;
    const { root } = backdrop({ status: status2, elevation, size });
    return /* @__PURE__ */ jsx5(
      motion3.div,
      {
        ref,
        className: root,
        variants: getBackdropVariants(coords, maskType, exited),
        custom: coords,
        initial: "closed",
        animate: "open",
        exit: "closed",
        children
      }
    );
  }
);
Overlay.displayName = "Overlay";
var getBackdropVariants = (coords, maskType, exited) => {
  const transitions = {
    backgroundSize: {
      duration: DURATION2.slow,
      ease: EASING.out
    },
    backdropFilter: {
      ease: EASING.out,
      duration: DURATION2.normal
    },
    opacity: {
      duration: DURATION2.normal,
      ease: EASING.inOut
    },
    maskImage: {
      duration: DURATION2.fast,
      ease: EASING.out
    }
  };
  const baseVariants = {
    open: {
      backgroundSize: "4px 4px",
      backdropFilter: "brightness(0.7) blur(3px)",
      opacity: 1
    },
    closed: {
      backgroundSize: "3px 3px",
      backdropFilter: "brightness(1) blur(5px)",
      opacity: 0
    }
  };
  if (coords === void 0 || maskType === void 0) {
    return {
      open: { ...baseVariants.open },
      closed: { ...baseVariants.closed }
    };
  }
  if (maskType === "origin") {
    return {
      open: ({ x, y }) => ({
        ...baseVariants.open,
        maskImage: `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,0) 100%, rgba(0,0,0,0) 100%)`,
        transition: {
          ...transitions,
          maskImage: {
            duration: DURATION2.slow,
            ease: EASING.in
          }
        }
      }),
      closed: ({ x, y }) => ({
        ...baseVariants.closed,
        maskImage: `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 100%, rgba(0,0,0,1) 100%, rgba(0,0,0,1) 100%)`,
        transition: {
          maskImage: {
            duration: DURATION2.slow,
            ease: EASING.out
          }
        }
      })
    };
  }
  return {
    open: ({ x, y }) => {
      if (exited) {
        return {
          ...baseVariants.open,
          maskImage: `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 100%, rgba(0,0,0,0) 100%, rgba(0,0,0,0) 100%)`,
          transition: {
            ...transitions,
            maskImage: {
              duration: DURATION2.slow,
              ease: EASING.in
            }
          }
        };
      }
      return {
        ...baseVariants.open,
        maskImage: `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 40%, rgba(0,0,0,0) 100%, rgba(0,0,0,0) 100%)`,
        transition: {
          ...transitions,
          maskImage: {
            duration: DURATION2.instant
          }
        }
      };
    },
    closed: ({ x, y }) => {
      if (exited) {
        return {
          ...baseVariants.closed,
          maskImage: `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 100%, rgba(0,0,0,0) 100%, rgba(0,0,0,0) 100%)`,
          transition: {
            maskImage: {
              duration: DURATION2.slow,
              ease: EASING.out
            }
          }
        };
      }
      return {
        ...baseVariants.closed,
        maskImage: `radial-gradient(circle at ${x}px ${y}px, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 100%, rgba(0,0,0,1) 100%, rgba(0,0,0,1) 100%)`,
        transition: {
          maskImage: {
            duration: DURATION2.slow,
            ease: EASING.out
          }
        }
      };
    }
  };
};
var ScrollContainer = React5.forwardRef(({ className, ...props }, ref) => {
  const { root } = scrollContainer({ size: "element" });
  return /* @__PURE__ */ jsx5("div", { ref, className: `${root}${className ? ` ${className}` : ""}`, ...props });
});
ScrollContainer.displayName = "ScrollContainer";

// src/components/toast/motion.ts
import { DELAY, DURATION as DURATION3, OPACITY as OPACITY2, SCALE, SPRING } from "@pinatagrams/design-system";
var toastStackVariants = {
  open: (index) => ({
    y: "0%",
    scale: SCALE.default,
    opacity: OPACITY2.visible,
    pointerEvents: "auto",
    cursor: "pointer",
    transition: {
      delay: DELAY.stagger(index)
    }
  }),
  closed: (index) => ({
    y: `${index * 100}%`,
    scale: SCALE.default - index * 0.08,
    opacity: OPACITY2.visible - index * 0.4,
    pointerEvents: index === 0 ? "auto" : "none",
    cursor: index === 0 ? "pointer" : "default",
    "--index": index,
    transition: {
      delay: DELAY.stagger(index)
    }
  }),
  exit: {
    opacity: OPACITY2.hidden,
    scale: SCALE.microDown,
    y: 20,
    transition: { duration: DURATION3.normal }
  },
  hover: {}
};
var caretVariants = {
  open: {
    x: 0,
    opacity: 1
  },
  closed: {
    x: 0,
    opacity: 0
  },
  hover: {
    x: 4
  }
};
var stackTransition = {
  ...SPRING.crisp
};

// src/components/toast/ToastItem.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var ToastItem = React6.forwardRef(
  ({
    status: status2,
    path,
    duration,
    index,
    reverseIndex,
    onOpenChange,
    open,
    title,
    description,
    progress
  }, ref) => {
    const { collapsed, setCollapsed } = React6.useContext(ToastStackContext);
    const classes = toastRecipe({
      status: status2,
      size: "md",
      state: collapsed ? "collapsed" : "expanded"
    });
    const Icon3 = (() => {
      switch (status2) {
        case "info":
          return InfoIcon;
        case "success":
          return CheckCircleIcon;
        case "warning":
          return WarningIcon;
        case "fatal":
          return SmileyXEyesIcon;
        case "error":
          return XCircleIcon;
        default:
          return InfoIcon;
      }
    })();
    const goToPath = () => {
      window.location.href = path.url;
    };
    const CaretIcon = motion4(CaretRightIcon);
    return /* @__PURE__ */ jsx6(
      Toast.Root,
      {
        open,
        onOpenChange,
        duration: duration ?? 0,
        asChild: true,
        forceMount: true,
        children: /* @__PURE__ */ jsxs5(
          motion4.section,
          {
            role: "status",
            "aria-live": "polite",
            className: classes.root,
            variants: toastStackVariants,
            custom: index,
            animate: collapsed ? "closed" : "open",
            exit: "exit",
            initial: false,
            whileHover: collapsed ? void 0 : "hover",
            onClick: collapsed ? setCollapsed.bind(null, false) : goToPath,
            "aria-label": collapsed ? `Go to ${path.label}` : void 0,
            style: {
              zIndex: reverseIndex
            },
            ref,
            children: [
              /* @__PURE__ */ jsx6(
                motion4.button,
                {
                  onClick: (e) => {
                    e.stopPropagation();
                    onOpenChange(false);
                  },
                  style: {
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center"
                  },
                  "aria-label": "Dismiss notification",
                  children: /* @__PURE__ */ jsx6(Icon3, { "data-icon-type": "status", weight: "bold" })
                }
              ),
              /* @__PURE__ */ jsxs5(Stack, { gap: "none", children: [
                title ? /* @__PURE__ */ jsx6(Toast.Title, { asChild: true, children: /* @__PURE__ */ jsx6("strong", { children: title }) }) : null,
                description ? /* @__PURE__ */ jsx6(Toast.Description, { asChild: true, "data-part": "description", children: /* @__PURE__ */ jsx6("span", { children: description }) }) : null,
                " ",
                typeof progress === "number" ? /* @__PURE__ */ jsx6("div", { style: { marginTop: "8px" }, children: /* @__PURE__ */ jsx6(
                  "div",
                  {
                    style: {
                      width: "100%",
                      height: "4px",
                      backgroundColor: "rgba(0,0,0,0.1)",
                      borderRadius: "2px",
                      overflow: "hidden"
                    },
                    role: "progressbar",
                    "aria-valuenow": progress,
                    "aria-valuemin": 0,
                    "aria-valuemax": 100,
                    "aria-label": `Progress: ${progress}%`,
                    children: /* @__PURE__ */ jsx6(
                      motion4.div,
                      {
                        initial: { width: 0 },
                        animate: { width: `${progress}%` },
                        transition: { duration: 0.3 },
                        style: {
                          height: "100%",
                          backgroundColor: "currentColor",
                          opacity: 0.6
                        }
                      }
                    )
                  }
                ) }) : null,
                " "
              ] }),
              /* @__PURE__ */ jsx6(
                CaretIcon,
                {
                  "data-icon-type": "caret",
                  weight: "bold",
                  variants: caretVariants,
                  transition: SPRING2.responsive
                }
              )
            ]
          }
        )
      }
    );
  }
);
ToastItem.displayName = "ToastItem";
var ToastItem_default = ToastItem;

// src/components/text/index.tsx
import React7 from "react";
import { textRecipe } from "@pinatagrams/design-system/recipes";
import { jsx as jsx7 } from "react/jsx-runtime";
var Title = React7.forwardRef(
  ({ hierarchy = "title", emphasis = "strong", className, children, ...props }, ref) => {
    const slots = textRecipe({ hierarchy, titleEmphasis: emphasis });
    const cls = slots.title;
    const Tag = hierarchy === "splash" ? "h1" : hierarchy === "subtitle" ? "h3" : "h2";
    return (
      // @ts-expect-error dynamic heading tag
      /* @__PURE__ */ jsx7(Tag, { ref, className: [cls, className].filter(Boolean).join(" "), ...props, children })
    );
  }
);
Title.displayName = "Title";
var Body = React7.forwardRef(
  ({ emphasis = "DEFAULT", className, children, ...props }, ref) => {
    const slots = textRecipe({ bodyEmphasis: emphasis });
    const cls = slots.body;
    return /* @__PURE__ */ jsx7("p", { ref, className: [cls, className].filter(Boolean).join(" "), ...props, children });
  }
);
Body.displayName = "Body";
var Supplemental = React7.forwardRef(
  ({ emphasis = "DEFAULT", className, children, ...props }, ref) => {
    const slots = textRecipe({ supplementalEmphasis: emphasis });
    const cls = slots.supplemental;
    return /* @__PURE__ */ jsx7(
      "code",
      {
        ref,
        className: [cls, className].filter(Boolean).join(" "),
        ...props,
        children
      }
    );
  }
);
Supplemental.displayName = "Supplemental";

// src/components/toast/toast-stack-context.tsx
import React8 from "react";
var ToastStackContext = React8.createContext({
  collapsed: false,
  setCollapsed: () => {
  },
  expandedToastId: void 0,
  setExpandedToastId: () => {
  },
  toastCount: 0,
  setToastCount: () => {
  }
});

// src/components/toast/toast-provider.tsx
import { Toast as Toast2 } from "radix-ui";
var ToastProvider = Toast2.Provider;

// src/components/toast/index.tsx
import { jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var ToastStackProvider = ({ children }) => {
  const [collapsed, setCollapsed] = React9.useState(false);
  const [expandedToastId, setExpandedToastId] = React9.useState(void 0);
  const [toastCount, setToastCount] = React9.useState(0);
  return /* @__PURE__ */ jsx8(
    ToastStackContext.Provider,
    {
      value: {
        collapsed,
        setCollapsed,
        expandedToastId,
        setExpandedToastId,
        toastCount,
        setToastCount
      },
      children
    }
  );
};
var Toasts = React9.forwardRef((props, forwardedRef) => {
  void props;
  const [toasts, setToasts] = React9.useState(
    []
  );
  const { setCollapsed, setToastCount } = React9.useContext(ToastStackContext);
  React9.useEffect(() => {
    const shouldExpand = toasts.length === 1;
    setCollapsed(!shouldExpand);
    setToastCount(toasts.length);
  }, [toasts.length, setCollapsed, setToastCount]);
  React9.useImperativeHandle(forwardedRef, () => ({
    publish: (toastData) => {
      const id = `toast-${Date.now()}`;
      setToasts((prev) => {
        const toast = { ...toastData, id, open: true };
        const next = [toast, ...prev];
        return next;
      });
      return id;
    },
    dismiss: (id) => {
      setToasts((prev) => prev.map((t) => t.id === id ? { ...t, open: false } : t));
    }
  }));
  const handleOpenChange = (id, open) => {
    if (!open) {
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 200);
    }
    setToasts((prev) => prev.map((t) => t.id === id ? { ...t, open } : t));
  };
  return /* @__PURE__ */ jsx8(AnimatePresence, { children: toasts.map((toastInstance, index) => /* @__PURE__ */ jsx8(
    ToastItem_default,
    {
      ...toastInstance,
      index,
      reverseIndex: toasts.length - index,
      onOpenChange: (open) => handleOpenChange(toastInstance.id, open)
    },
    toastInstance.id
  )) });
});
var Viewport = (props) => {
  const { collapsed } = React9.useContext(ToastStackContext);
  const viewportRef = React9.useRef(null);
  const container = useLayerContainer();
  const stackVariants = {
    open: {
      scale: 0.9,
      cursor: "pointer",
      maxHeight: "none"
    },
    closed: {
      y: 0,
      scale: 1,
      cursor: "default",
      maxHeight: "3.5rem"
    }
  };
  return /* @__PURE__ */ jsx8(Portal.Root, { container, asChild: true, children: /* @__PURE__ */ jsxs6(motion5.section, { className: toastRecipe2().viewport, children: [
    /* @__PURE__ */ jsx8(StackHeader, {}),
    /* @__PURE__ */ jsx8(Toast3.Viewport, { asChild: true, ...props, children: /* @__PURE__ */ jsx8(
      motion5.ol,
      {
        ref: viewportRef,
        className: toastRecipe2().list,
        variants: stackVariants,
        initial: false,
        animate: collapsed ? "closed" : "open",
        style: { overflow: collapsed ? "hidden" : "visible" }
      }
    ) })
  ] }) });
};
Viewport.displayName = "ToastViewport";
var StackHeader = () => {
  const { setCollapsed, collapsed, toastCount } = React9.useContext(ToastStackContext);
  const variants3 = {
    open: { y: 0, scale: 1, opacity: 1 },
    closed: { y: 60, scale: 0.8, opacity: 0 }
  };
  if (toastCount < 2) return null;
  return /* @__PURE__ */ jsxs6(
    motion5.header,
    {
      className: toastRecipe2().header,
      variants: variants3,
      initial: "closed",
      animate: collapsed ? "closed" : "open",
      transition: {
        type: "spring",
        stiffness: 600,
        damping: 50,
        delay: collapsed ? 0.2 : 0
      },
      children: [
        /* @__PURE__ */ jsx8(Title, { children: "Notifications" }),
        /* @__PURE__ */ jsx8(button_default, { size: "sm", onClick: () => setCollapsed(true), children: "Collapse" })
      ]
    }
  );
};
StackHeader.displayName = "ToastStackHeader";
var ToastWithViewport = Object.assign(Toasts, { Viewport });
Toasts.displayName = "Toasts";
var toast_default = ToastWithViewport;

// src/hooks/use-feedback-event.tsx
import { useCallback as useCallback2, createContext, useContext } from "react";
import { useShallow } from "zustand/react/shallow";

// src/hooks/feedback-store.ts
import { create } from "zustand";
var createFeedbackStore = (set, get) => ({
  // State
  outcomesById: {},
  alerts: [],
  toasts: [],
  bannersByOrigin: {},
  bannerRegistry: {},
  // Actions
  emit: (params) => {
    const id = `feedback-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    const now = Date.now();
    const record = {
      ...params,
      id,
      createdAt: now,
      updatedAt: now
    };
    set((state) => {
      const newState = {
        ...state,
        outcomesById: {
          ...state.outcomesById,
          [id]: record
        }
      };
      if (params.impact === "blocking") {
        newState.alerts = [...state.alerts, id];
      } else {
        newState.toasts = [...state.toasts, id];
      }
      return newState;
    });
    return id;
  },
  update: (id, patch) => {
    set((state) => {
      const outcome = state.outcomesById[id];
      if (!outcome) return state;
      return {
        ...state,
        outcomesById: {
          ...state.outcomesById,
          [id]: {
            ...outcome,
            ...patch,
            updatedAt: Date.now()
          }
        }
      };
    });
  },
  dismiss: (id) => {
    set((state) => {
      const outcome = state.outcomesById[id];
      if (!outcome) return state;
      const newState = {
        ...state,
        alerts: state.alerts.filter((aid) => aid !== id),
        toasts: state.toasts.filter((tid) => tid !== id),
        bannersByOrigin: Object.fromEntries(
          Object.entries(state.bannersByOrigin).map(([originId, ids]) => [
            originId,
            ids.filter((bid) => bid !== id)
          ])
        ),
        outcomesById: { ...state.outcomesById }
      };
      Object.keys(newState.bannersByOrigin).forEach((originId) => {
        if (newState.bannersByOrigin[originId].length === 0) {
          delete newState.bannersByOrigin[originId];
        }
      });
      delete newState.outcomesById[id];
      return newState;
    });
  },
  clearOrigin: (originId) => {
    set((state) => {
      const bannerIds = state.bannersByOrigin[originId] || [];
      const newState = {
        ...state,
        bannersByOrigin: { ...state.bannersByOrigin },
        outcomesById: { ...state.outcomesById }
      };
      bannerIds.forEach((id) => {
        delete newState.outcomesById[id];
      });
      delete newState.bannersByOrigin[originId];
      return newState;
    });
  },
  registerBanner: (originId) => {
    set((state) => ({
      ...state,
      bannerRegistry: {
        ...state.bannerRegistry,
        [originId]: true
      }
    }));
    return () => {
      set((state) => {
        const newRegistry = { ...state.bannerRegistry };
        delete newRegistry[originId];
        return { ...state, bannerRegistry: newRegistry };
      });
      get().clearOrigin(originId);
    };
  },
  // Selectors
  getOutcome: (id) => {
    const outcome = get().outcomesById[id];
    return outcome;
  },
  getBannersForOrigin: (originId) => {
    const state = get();
    const bannerIds = state.bannersByOrigin[originId] || [];
    const filtered = bannerIds.map((id) => state.outcomesById[id]).filter((outcome) => Boolean(outcome));
    return filtered;
  },
  getAlerts: () => {
    const state = get();
    const filtered = state.alerts.map((id) => state.outcomesById[id]).filter((outcome) => Boolean(outcome));
    return filtered;
  },
  getToasts: () => {
    const state = get();
    const filtered = state.toasts.map((id) => state.outcomesById[id]).filter((outcome) => Boolean(outcome));
    return filtered;
  }
});
var useFeedbackStore = create(createFeedbackStore);

// src/hooks/use-feedback-event.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
var FeedbackEventContext = createContext(null);
function FeedbackEventProvider({ children }) {
  return /* @__PURE__ */ jsx9(FeedbackEventContext.Provider, { value: { _legacy: true }, children });
}
function useFeedbackEvent() {
  const context = useContext(FeedbackEventContext);
  if (!context) {
    throw new Error("useOutcome must be used within an OutcomeProvider");
  }
  const currentPath = typeof window !== "undefined" ? window.location.pathname : "";
  const {
    outcomesById,
    alerts: alertIds,
    toasts: toastIds,
    bannerRegistry,
    emit: storeEmit,
    update: storeUpdate,
    dismiss: storeDismiss,
    clearOrigin: storeClearOrigin,
    registerBanner: storeRegisterBanner,
    getBannersForOrigin: storeGetBannersForOrigin
  } = useFeedbackStore(
    useShallow((state) => ({
      outcomesById: state.outcomesById,
      alerts: state.alerts,
      toasts: state.toasts,
      bannerRegistry: state.bannerRegistry,
      emit: state.emit,
      update: state.update,
      dismiss: state.dismiss,
      clearOrigin: state.clearOrigin,
      registerBanner: state.registerBanner,
      getBannersForOrigin: state.getBannersForOrigin
    }))
  );
  const emit = useCallback2(
    (params) => {
      const originPath = params.origin.path ?? currentPath;
      const resolvedOrigin = { ...params.origin, path: originPath };
      const id = storeEmit({
        ...params,
        origin: resolvedOrigin
      });
      const isRegistered = bannerRegistry[params.origin.id];
      const isOnOriginPath = originPath === currentPath;
      if (params.impact === "blocking") {
        if (!isOnOriginPath) {
          useFeedbackStore.setState((state) => {
            const newState = { ...state };
            newState.alerts = newState.alerts.filter((aid) => aid !== id);
            newState.toasts = [...newState.toasts, id];
            return newState;
          });
        }
      } else if (params.impact === "permissive") {
        if (isRegistered && isOnOriginPath) {
          useFeedbackStore.setState((state) => {
            const newState = { ...state };
            newState.toasts = newState.toasts.filter((tid) => tid !== id);
            const originBanners = newState.bannersByOrigin[params.origin.id] || [];
            newState.bannersByOrigin[params.origin.id] = [...originBanners, id];
            return newState;
          });
        }
      }
      return id;
    },
    [storeEmit, bannerRegistry, currentPath]
  );
  const update = useCallback2(
    (id, patch) => {
      storeUpdate(id, {
        title: patch.title,
        message: patch.message,
        progress: patch.progress,
        success: patch.success,
        severity: patch.severity,
        actions: patch.actions
      });
    },
    [storeUpdate]
  );
  const clear = useCallback2(
    (id) => {
      storeDismiss(id);
    },
    [storeDismiss]
  );
  const clearOriginFn = useCallback2(
    (originId) => {
      storeClearOrigin(originId);
    },
    [storeClearOrigin]
  );
  const registerBanner = useCallback2(
    (registration) => {
      const unregister = storeRegisterBanner(registration.originId);
      return unregister;
    },
    [storeRegisterBanner]
  );
  const getBannersForOrigin = useCallback2(
    (originId) => {
      const banners = storeGetBannersForOrigin(originId);
      return banners.map((event) => ({
        origin: event.origin,
        impact: event.impact,
        severity: event.severity,
        title: event.title,
        message: event.message,
        actions: event.actions,
        intent: event.intent,
        success: event.success,
        progress: event.progress,
        id: event.id
      }));
    },
    [storeGetBannersForOrigin]
  );
  const dismissAlert = useCallback2(() => {
    if (alertIds.length > 0) {
      storeDismiss(alertIds[0]);
    }
  }, [alertIds, storeDismiss]);
  const dismissToast = useCallback2(
    (index) => {
      if (toastIds[index]) {
        storeDismiss(toastIds[index]);
      }
    },
    [toastIds, storeDismiss]
  );
  const alert = alertIds.length > 0 && outcomesById[alertIds[0]] ? outcomesById[alertIds[0]] : null;
  const eventsByIdMap = outcomesById;
  const toastIdList = toastIds;
  const toasts = toastIdList.map((id) => eventsByIdMap[id]).filter(
    (event) => Boolean(event)
  );
  return {
    emit,
    update,
    clear,
    clearOrigin: clearOriginFn,
    registerBanner,
    getBannersForOrigin,
    alert: alert ? {
      origin: alert.origin,
      impact: alert.impact,
      severity: alert.severity,
      title: alert.title,
      message: alert.message,
      actions: alert.actions,
      intent: alert.intent,
      success: alert.success,
      progress: alert.progress
    } : null,
    dismissAlert,
    toasts: toasts.map(
      (event) => ({
        origin: event.origin,
        impact: event.impact,
        severity: event.severity,
        title: event.title,
        message: event.message,
        actions: event.actions,
        intent: event.intent,
        success: event.success,
        progress: event.progress
      })
    ),
    dismissToast
  };
}

// src/hooks/feedback-event-utils.ts
function getFeedbackEventStatus(event) {
  if (!event) return "info";
  if (event.success === true) return "success";
  if (event.severity === "fatal") return "fatal";
  if (event.severity === "nonfatal") return "error";
  if (event.intent === "object") return "warning";
  if (event.intent === "confirm") return "info";
  return "info";
}

// src/providers.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
function FiestaProvider({ children, ...tooltipProps }) {
  return /* @__PURE__ */ jsx10(layer_context_default, { children: /* @__PURE__ */ jsx10(TooltipProvider, { ...tooltipProps, children: /* @__PURE__ */ jsx10(ToastProvider, { children: /* @__PURE__ */ jsx10(FeedbackEventProvider, { children }) }) }) });
}

// src/components/outcome-renderer/index.tsx
import React12 from "react";
import { useShallow as useShallow2 } from "zustand/react/shallow";

// src/components/banner/index.tsx
import React10 from "react";
import { motion as motion6, AnimatePresence as AnimatePresence2 } from "motion/react";
import { banner } from "@pinatagrams/design-system/recipes";
import {
  CheckCircleIcon as CheckCircleIcon2,
  WarningIcon as WarningIcon2,
  SmileyXEyesIcon as SmileyXEyesIcon2,
  InfoIcon as InfoIcon2,
  XCircleIcon as XCircleIcon2
} from "@phosphor-icons/react";
import { jsx as jsx11, jsxs as jsxs7 } from "react/jsx-runtime";
var getBannerStatus = (value) => {
  if (!value) return "info";
  if (value.success === true) return "success";
  if (value.severity === "fatal") return "fatal";
  if (value.severity === "nonfatal") return "error";
  if (value.intent === "object") return "warning";
  if (value.intent === "confirm") return "info";
  return "info";
};
var Banner = ({ value }) => {
  const status2 = getBannerStatus(value);
  const { root: classes, action: actionClasses } = banner({ status: status2 });
  const Badge2 = (() => {
    switch (status2) {
      case "success":
        return CheckCircleIcon2;
      case "warning":
        return WarningIcon2;
      case "fatal":
        return SmileyXEyesIcon2;
      case "error":
        return XCircleIcon2;
      case "info":
        return InfoIcon2;
      default:
        return InfoIcon2;
    }
  })();
  return /* @__PURE__ */ jsx11(AnimatePresence2, { mode: "popLayout", children: value && /* @__PURE__ */ jsxs7(
    motion6.article,
    {
      className: classes,
      role: "region",
      "aria-live": "polite",
      variants: variants2[status2 === "success" ? "ok" : "error"],
      initial: "hidden",
      animate: "visible",
      exit: "hidden",
      transition: {
        clipPath: { duration: 0.6, ease: "easeInOut" },
        opacity: { duration: 0.3 }
      },
      children: [
        /* @__PURE__ */ jsxs7(Stack, { children: [
          /* @__PURE__ */ jsxs7(Inline, { justify: "between", children: [
            value.title ? /* @__PURE__ */ jsx11("strong", { children: value.title }) : null,
            /* @__PURE__ */ jsx11(Badge2, { "data-icon-status": true, weight: "bold" })
          ] }),
          value.message ? /* @__PURE__ */ jsx11(Body, { children: value.message }) : null,
          typeof value.progress === "number" ? /* @__PURE__ */ jsx11("div", { style: { marginTop: "8px" }, children: /* @__PURE__ */ jsx11(
            "div",
            {
              style: {
                width: "100%",
                height: "4px",
                backgroundColor: "rgba(0,0,0,0.1)",
                borderRadius: "2px",
                overflow: "hidden"
              },
              role: "progressbar",
              "aria-valuenow": value.progress,
              "aria-valuemin": 0,
              "aria-valuemax": 100,
              "aria-label": `Progress: ${value.progress}%`,
              children: /* @__PURE__ */ jsx11(
                motion6.div,
                {
                  initial: { width: 0 },
                  animate: { width: `${value.progress}%` },
                  transition: { duration: 0.3 },
                  style: {
                    height: "100%",
                    backgroundColor: "currentColor",
                    opacity: 0.6
                  }
                }
              )
            }
          ) }) : null
        ] }),
        value.actions?.length ? /* @__PURE__ */ jsx11("div", { className: actionClasses, children: value.actions.map((action, index) => {
          const button2 = /* @__PURE__ */ jsx11(button_default, { emphasis: "subtle", onClick: action.onClick, disabled: action.disabled, children: action.label });
          return action.tooltip ? /* @__PURE__ */ jsxs7(tooltip_default, { children: [
            /* @__PURE__ */ jsx11(tooltip_default.Trigger, { children: button2 }),
            /* @__PURE__ */ jsx11(tooltip_default.Content, { children: action.tooltip })
          ] }, index) : /* @__PURE__ */ jsx11(React10.Fragment, { children: button2 }, index);
        }) }) : null
      ]
    },
    value.id ?? value.origin.id
  ) });
};
Banner.displayName = "Banner";
var banner_default = Banner;
var variants2 = {
  ok: {
    hidden: {
      clipPath: "circle(0% at 0% 0%)",
      opacity: 0
    },
    visible: {
      clipPath: "circle(150% at 0% 0%)",
      opacity: 1
    }
  },
  error: {
    hidden: {
      x: 0,
      opacity: 0
    },
    visible: {
      x: [-10, 10, -10, 10, -5, 5, 0],
      opacity: 1
    }
  }
};

// src/components/alert-dialog/index.tsx
import { motion as motion7, AnimatePresence as AnimatePresence3 } from "motion/react";
import { AlertDialog as RadixAlertDialog } from "radix-ui";
import { DELAY as DELAY2, DURATION as DURATION4, EASING as EASING2 } from "@pinatagrams/design-system";
import { alertDialog } from "@pinatagrams/design-system/recipes";
import { jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
var AlertDialogRoot = ({ open, onOpenChange, children }) => {
  return /* @__PURE__ */ jsx12(RadixAlertDialog.Root, { open, onOpenChange, children });
};
var AlertDialogTrigger = ({ children }) => {
  return /* @__PURE__ */ jsx12(RadixAlertDialog.Trigger, { asChild: true, children });
};
var AlertDialogContent = ({
  status: status2 = "info",
  showOverlay = true,
  children,
  ...props
}) => {
  const container = useLayerContainer();
  const recipeStatus = status2 === "info" ? "confirm" : status2;
  const { root: contentClass } = alertDialog({
    success: recipeStatus
  });
  return /* @__PURE__ */ jsx12(AnimatePresence3, { children: /* @__PURE__ */ jsxs8(RadixAlertDialog.Portal, { container, children: [
    showOverlay && /* @__PURE__ */ jsx12(RadixAlertDialog.Overlay, { asChild: true, children: /* @__PURE__ */ jsx12(Overlay, { status: status2 }) }),
    /* @__PURE__ */ jsx12(RadixAlertDialog.Content, { className: contentClass, ...props, asChild: true, children: /* @__PURE__ */ jsx12(
      motion7.article,
      {
        role: "presentation",
        variants: contentVariants,
        initial: "closed",
        animate: "open",
        exit: "closed",
        children
      }
    ) })
  ] }) });
};
var AlertDialogTitle = ({ children }) => {
  return /* @__PURE__ */ jsx12(RadixAlertDialog.Title, { asChild: true, children: /* @__PURE__ */ jsx12(Title, { hierarchy: "subtitle", children }) });
};
var AlertDialogDescription = ({ children }) => {
  return /* @__PURE__ */ jsx12(RadixAlertDialog.Description, { asChild: true, children: /* @__PURE__ */ jsx12(Body, { children }) });
};
var AlertDialogActions = ({ children }) => {
  const { actions: actionsClass } = alertDialog({});
  return /* @__PURE__ */ jsx12("footer", { className: actionsClass, children });
};
var AlertDialogAction = ({
  emphasis = "bold",
  onClick,
  children
}) => {
  return /* @__PURE__ */ jsx12(RadixAlertDialog.Action, { asChild: true, children: /* @__PURE__ */ jsx12(button_default, { emphasis, onClick, children }) });
};
var AlertDialogCancel = ({
  emphasis = "ghost",
  onClick,
  children
}) => {
  return /* @__PURE__ */ jsx12(RadixAlertDialog.Cancel, { asChild: true, children: /* @__PURE__ */ jsx12(button_default, { emphasis, onClick, children }) });
};
var contentVariants = {
  open: {
    y: "0%",
    opacity: 1,
    transition: { duration: DURATION4.moderate, ease: EASING2.out, delay: DELAY2.long }
  },
  closed: {
    y: "30%",
    opacity: 0,
    transition: { duration: DURATION4.moderate, ease: EASING2.in }
  }
};
var AlertDialog = Object.assign(AlertDialogRoot, {
  Trigger: AlertDialogTrigger,
  Content: AlertDialogContent,
  Title: AlertDialogTitle,
  Description: AlertDialogDescription,
  Actions: AlertDialogActions,
  Action: AlertDialogAction,
  Cancel: AlertDialogCancel
});

// src/components/outcome-renderer/index.tsx
import { WarningCircleIcon, WarningIcon as WarningIcon3, SmileyXEyesIcon as SmileyXEyesIcon3 } from "@phosphor-icons/react";

// src/components/badge/index.tsx
import React11 from "react";
import { badge } from "@pinatagrams/design-system/recipes";
import { jsx as jsx13 } from "react/jsx-runtime";
var Badge = React11.forwardRef(
  ({ color, size = "md", children, ...props }, ref) => {
    const className = badge({ color, size });
    return /* @__PURE__ */ jsx13("span", { ref, role: "status", "aria-live": "polite", className, ...props, children });
  }
);
Badge.displayName = "Badge";
var badge_default = Badge;

// src/components/outcome-renderer/index.tsx
import { Fragment as Fragment2, jsx as jsx14, jsxs as jsxs9 } from "react/jsx-runtime";
function FeedbackEventRenderer({ currentOriginId }) {
  const { dismissAlert } = useFeedbackEvent();
  const [alertOpen, setAlertOpen] = React12.useState(false);
  const toastRef = React12.useRef(null);
  const {
    outcomesById,
    alerts: alertIds,
    toasts: toastIds,
    bannersByOrigin,
    bannerRegistry
  } = useFeedbackStore(
    useShallow2((state) => ({
      outcomesById: state.outcomesById,
      alerts: state.alerts,
      toasts: state.toasts,
      bannersByOrigin: state.bannersByOrigin,
      bannerRegistry: state.bannerRegistry
    }))
  );
  const alertOutcome = alertIds.length > 0 ? outcomesById[alertIds[0]] : null;
  const bannerOutcome = currentOriginId && bannersByOrigin[currentOriginId] ? bannersByOrigin[currentOriginId].map((id) => outcomesById[id]).filter((outcome) => Boolean(outcome)).sort((a, b) => b.updatedAt - a.updatedAt)[0] : null;
  const visibleToastIds = toastIds.filter((id) => {
    const outcome = outcomesById[id];
    if (!outcome) return false;
    if (currentOriginId && outcome.origin.id === currentOriginId && bannerRegistry[outcome.origin.id]) {
      return false;
    }
    return true;
  });
  const convertToToastData = React12.useCallback((outcome) => {
    if (!outcome) return { title: "", status: "info", path: { label: "/", url: "/" } };
    const status2 = getFeedbackEventStatus(outcome);
    return {
      title: outcome.title,
      description: outcome.message,
      status: status2,
      progress: outcome.progress,
      path: { label: outcome.origin.path ?? "/", url: outcome.origin.path ?? "/" }
    };
  }, []);
  React12.useEffect(() => {
    setAlertOpen(Boolean(alertOutcome));
  }, [alertOutcome]);
  React12.useEffect(() => {
    if (visibleToastIds.length > 0 && toastRef.current) {
      const latestToastId = visibleToastIds[visibleToastIds.length - 1];
      const latestToast = outcomesById[latestToastId];
      if (latestToast) {
        toastRef.current.publish(convertToToastData(latestToast));
      }
    }
  }, [visibleToastIds, outcomesById, convertToToastData]);
  const handleAlertDismiss = React12.useCallback(() => {
    setAlertOpen(false);
    dismissAlert();
  }, [dismissAlert]);
  const getBadgeData = React12.useCallback((status2) => {
    switch (status2) {
      case "fatal":
        return { label: "Error", Icon: SmileyXEyesIcon3, color: "error" };
      case "warning":
        return { label: "Warning", Icon: WarningIcon3, color: "warning" };
      case "info":
        return { label: "Confirm", Icon: WarningCircleIcon, color: "info" };
      default:
        return { label: "Alert", Icon: WarningCircleIcon, color: "info" };
    }
  }, []);
  const alertStatus = alertOutcome ? getFeedbackEventStatus(alertOutcome) : "info";
  const badgeData = getBadgeData(alertStatus);
  const hasActions = alertOutcome?.actions && alertOutcome.actions.length > 0;
  return /* @__PURE__ */ jsxs9(Fragment2, { children: [
    bannerOutcome && /* @__PURE__ */ jsx14(Wrapper, { layer: 0 /* Main */, children: /* @__PURE__ */ jsx14(
      banner_default,
      {
        value: {
          origin: bannerOutcome.origin,
          impact: bannerOutcome.impact,
          severity: bannerOutcome.severity,
          title: bannerOutcome.title,
          message: bannerOutcome.message,
          actions: bannerOutcome.actions,
          intent: bannerOutcome.intent,
          success: bannerOutcome.success,
          progress: bannerOutcome.progress,
          id: bannerOutcome.id
        }
      }
    ) }),
    /* @__PURE__ */ jsx14(Wrapper, { layer: 4 /* Overlay */, children: /* @__PURE__ */ jsx14(AlertDialog, { open: alertOpen, onOpenChange: handleAlertDismiss, children: /* @__PURE__ */ jsxs9(AlertDialog.Content, { status: alertStatus, children: [
      /* @__PURE__ */ jsxs9(Stack, { children: [
        /* @__PURE__ */ jsxs9(Inline, { justify: "between", children: [
          /* @__PURE__ */ jsx14(AlertDialog.Title, { children: alertOutcome?.title || "Alert" }),
          /* @__PURE__ */ jsxs9(tooltip_default, { children: [
            /* @__PURE__ */ jsx14(tooltip_default.Trigger, { children: /* @__PURE__ */ jsx14("span", { children: /* @__PURE__ */ jsxs9(badge_default, { color: badgeData.color, children: [
              /* @__PURE__ */ jsx14(badgeData.Icon, { size: 14, weight: "bold" }),
              " ",
              badgeData.label
            ] }) }) }),
            /* @__PURE__ */ jsx14(tooltip_default.Content, { children: badgeData.label })
          ] })
        ] }),
        alertOutcome?.message && /* @__PURE__ */ jsx14(AlertDialog.Description, { children: alertOutcome.message })
      ] }),
      /* @__PURE__ */ jsx14(AlertDialog.Actions, { children: hasActions ? /* @__PURE__ */ jsxs9(Fragment2, { children: [
        /* @__PURE__ */ jsx14(AlertDialog.Cancel, { onClick: handleAlertDismiss, children: "Cancel" }),
        alertOutcome?.actions.map((action, index) => /* @__PURE__ */ jsx14(
          AlertDialog.Action,
          {
            emphasis: alertStatus === "info" ? "bold" : "subtle",
            onClick: () => {
              action.onClick();
              handleAlertDismiss();
            },
            children: action.label
          },
          `alert-action-${action.label}-${index}`
        ))
      ] }) : /* @__PURE__ */ jsx14(AlertDialog.Action, { onClick: handleAlertDismiss, children: "OK" }) })
    ] }) }) }),
    /* @__PURE__ */ jsx14(Wrapper, { layer: 3 /* Toasts */, children: /* @__PURE__ */ jsx14(ToastProvider, { duration: Infinity, children: /* @__PURE__ */ jsxs9(ToastStackProvider, { children: [
      /* @__PURE__ */ jsx14(toast_default, { ref: toastRef }),
      /* @__PURE__ */ jsx14(toast_default.Viewport, {})
    ] }) }) })
  ] });
}
FeedbackEventRenderer.displayName = "FeedbackEventRenderer";
var OutcomeRenderer = FeedbackEventRenderer;

// src/components/dialog/index.tsx
import { motion as motion8, AnimatePresence as AnimatePresence4 } from "motion/react";
import { Dialog as RadixDialog } from "radix-ui";
import { DELAY as DELAY3, DURATION as DURATION5, EASING as EASING3 } from "@pinatagrams/design-system";
import { dialog } from "@pinatagrams/design-system/recipes";
import { jsx as jsx15, jsxs as jsxs10 } from "react/jsx-runtime";
var DialogRoot = ({ open, onOpenChange, children }) => {
  return /* @__PURE__ */ jsx15(RadixDialog.Root, { open, onOpenChange, children });
};
var DialogTrigger = ({ children }) => {
  return /* @__PURE__ */ jsx15(RadixDialog.Trigger, { asChild: true, children });
};
var DialogContent = ({
  showOverlay = true,
  children,
  ...props
}) => {
  const container = useLayerContainer();
  const { root: contentClass, close: closeClass } = dialog({});
  return /* @__PURE__ */ jsx15(AnimatePresence4, { children: /* @__PURE__ */ jsxs10(RadixDialog.Portal, { container, children: [
    showOverlay && /* @__PURE__ */ jsx15(RadixDialog.Overlay, { asChild: true, children: /* @__PURE__ */ jsx15(Overlay, { status: "info" }) }),
    /* @__PURE__ */ jsx15(RadixDialog.Content, { className: contentClass, ...props, asChild: true, children: /* @__PURE__ */ jsxs10(
      motion8.article,
      {
        role: "presentation",
        variants: contentVariants2,
        initial: "closed",
        animate: "open",
        exit: "closed",
        children: [
          /* @__PURE__ */ jsx15(RadixDialog.Close, { asChild: true, children: /* @__PURE__ */ jsx15(button_default, { emphasis: "ghost", size: "sm", className: closeClass, "aria-label": "Close dialog", children: "Close" }) }),
          children
        ]
      }
    ) })
  ] }) });
};
var DialogTitle = ({ children }) => {
  const { title: titleClass } = dialog({});
  return /* @__PURE__ */ jsx15(RadixDialog.Title, { asChild: true, children: /* @__PURE__ */ jsx15(Title, { hierarchy: "subtitle", className: titleClass, children }) });
};
var DialogBody = ({ children }) => {
  const { body: bodyClass } = dialog({});
  return /* @__PURE__ */ jsx15("div", { className: bodyClass, children });
};
var DialogFooter = ({ children }) => {
  const { footer: footerClass } = dialog({});
  return /* @__PURE__ */ jsx15("footer", { className: footerClass, children });
};
var contentVariants2 = {
  open: {
    y: "0%",
    opacity: 1,
    transition: { duration: DURATION5.moderate, ease: EASING3.out, delay: DELAY3.long }
  },
  closed: {
    y: "30%",
    opacity: 0,
    transition: { duration: DURATION5.moderate, ease: EASING3.in }
  }
};
var Dialog = Object.assign(DialogRoot, {
  Trigger: DialogTrigger,
  Content: DialogContent,
  Title: DialogTitle,
  Body: DialogBody,
  Footer: DialogFooter
});

// src/patterns/index.ts
var patterns_exports = {};
__export(patterns_exports, {
  DraggableBadge: () => draggable_badge_default,
  FulfillmentBatchCard: () => fulfillment_batch_card_default,
  Navigation: () => navigation_default,
  ProfileHeader: () => profile_header_default,
  STATEFUL_BUTTON_STATES: () => STATEFUL_BUTTON_STATES,
  StatefulButton: () => StatefulButton,
  UserCard: () => user_card_default,
  WorkflowCard: () => workflow_card_default,
  WorkflowDataBlock: () => WorkflowDataBlock,
  WorkflowDetailItem: () => WorkflowDetailItem
});

// src/patterns/stateful-button/index.tsx
import React13, { useState, useEffect, useRef } from "react";
import { AnimatePresence as AnimatePresence5, motion as motion9, useTime, useTransform, animate } from "motion/react";
import { DELAY as DELAY4, DURATION as DURATION6, EASING as EASING4, OPACITY as OPACITY3, SCALE as SCALE2, SPRING as SPRING3 } from "@pinatagrams/design-system";

// src/patterns/stateful-button/constants.ts
var STATEFUL_BUTTON_STATES = {
  idle: "Start",
  processing: "Processing",
  success: "Done",
  error: "Something went wrong"
};

// src/patterns/stateful-button/index.tsx
import { Fragment as Fragment3, jsx as jsx16, jsxs as jsxs11 } from "react/jsx-runtime";
var SPRING_CONFIG = SPRING3.tight;
var ICON_SIZE = 20;
var STROKE_WIDTH = 1.5;
var VIEW_BOX_SIZE = 24;
var svgProps = {
  width: ICON_SIZE,
  height: ICON_SIZE,
  viewBox: `0 0 ${VIEW_BOX_SIZE} ${VIEW_BOX_SIZE}`,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: STROKE_WIDTH,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
var pathSpring = SPRING3.gentle;
var pathAnim = { initial: { pathLength: 0 }, animate: { pathLength: 1 }, transition: pathSpring };
var StatefulButton = React13.forwardRef(
  function StatefulButton2({ state = "idle", labels, "aria-label": ariaLabel, ...buttonProps }, ref) {
    const defaultLabel = STATEFUL_BUTTON_STATES[state];
    const label2 = labels?.[state] ?? defaultLabel;
    const badgeRef = React13.useRef(null);
    React13.useEffect(() => {
      const el = badgeRef.current;
      if (!el) return;
      if (state === "error") {
        animate(
          el,
          { x: [0, -6, 6, -6, 0] },
          {
            duration: DURATION6.slow,
            ease: EASING4.inOut,
            times: [0, 0.25, 0.5, 0.75, 1],
            repeat: 0,
            delay: DELAY4.short
          }
        );
      } else if (state === "success") {
        animate(
          el,
          { scale: [SCALE2.default, SCALE2.mediumUp, SCALE2.default] },
          {
            duration: DURATION6.slow,
            ease: EASING4.inOut,
            times: [0, 0.5, 1],
            repeat: 0
          }
        );
      }
    }, [state]);
    const ariaBusy = state === "processing" ? true : void 0;
    const ariaInvalid = state === "error" ? true : void 0;
    return /* @__PURE__ */ jsx16(
      Button,
      {
        ref,
        "aria-busy": ariaBusy,
        "aria-invalid": ariaInvalid,
        "aria-live": state === "idle" ? void 0 : "polite",
        "aria-label": ariaLabel ?? (typeof label2 === "string" ? label2 : void 0),
        "data-success": state === "success" || void 0,
        "data-error": state === "error" || void 0,
        ...buttonProps,
        children: /* @__PURE__ */ jsxs11(
          motion9.span,
          {
            ref: badgeRef,
            style: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: state === "idle" ? 0 : 8,
              overflow: "hidden",
              willChange: "transform, filter"
            },
            children: [
              /* @__PURE__ */ jsx16(Icon, { state }),
              /* @__PURE__ */ jsx16(Label2, { state, children: label2 })
            ]
          }
        )
      }
    );
  }
);
var Icon = ({ state }) => /* @__PURE__ */ jsx16(
  motion9.span,
  {
    style: {
      height: ICON_SIZE,
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: ICON_SIZE,
      overflow: "hidden"
    },
    animate: { width: state === "idle" ? 0 : ICON_SIZE },
    transition: SPRING_CONFIG,
    children: /* @__PURE__ */ jsx16(AnimatePresence5, { children: /* @__PURE__ */ jsx16(
      motion9.span,
      {
        style: { position: "absolute", left: 0, top: 0 },
        initial: { y: -40, scale: SCALE2.heavyDown, opacity: OPACITY3.hidden },
        animate: { y: 0, scale: SCALE2.default, opacity: OPACITY3.visible },
        exit: { y: 40, scale: SCALE2.heavyDown, opacity: OPACITY3.hidden },
        transition: { duration: DURATION6.fast, ease: EASING4.inOut },
        "aria-hidden": true,
        children: /* @__PURE__ */ jsx16(StateIcon, { state })
      },
      state
    ) })
  }
);
function StateIcon({ state }) {
  switch (state) {
    case "idle":
      return null;
    case "processing":
      return /* @__PURE__ */ jsx16(Loader, {});
    case "success":
      return /* @__PURE__ */ jsx16(Check, {});
    case "error":
      return /* @__PURE__ */ jsx16(X, {});
    default:
      return null;
  }
}
function Check() {
  return /* @__PURE__ */ jsx16(motion9.svg, { ...svgProps, "aria-hidden": true, children: /* @__PURE__ */ jsx16(motion9.polyline, { points: "4 12 9 17 20 6", ...pathAnim }) });
}
function Loader() {
  const time = useTime();
  const rotate = useTransform(time, [0, 1e3], [0, 360], { clamp: false });
  return /* @__PURE__ */ jsx16(
    motion9.div,
    {
      style: {
        rotate,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: ICON_SIZE,
        height: ICON_SIZE
      },
      "aria-hidden": true,
      children: /* @__PURE__ */ jsx16(motion9.svg, { ...svgProps, children: /* @__PURE__ */ jsx16(motion9.path, { d: "M21 12a9 9 0 1 1-6.219-8.56", ...pathAnim }) })
    }
  );
}
function X() {
  return /* @__PURE__ */ jsxs11(motion9.svg, { ...svgProps, "aria-hidden": true, children: [
    /* @__PURE__ */ jsx16(motion9.line, { x1: "6", y1: "6", x2: "18", y2: "18", ...pathAnim }),
    /* @__PURE__ */ jsx16(
      motion9.line,
      {
        x1: "18",
        y1: "6",
        x2: "6",
        y2: "18",
        ...{ ...pathAnim, transition: { ...pathSpring, delay: DELAY4.short } }
      }
    )
  ] });
}
var Label2 = ({
  state,
  children
}) => {
  const [labelWidth, setLabelWidth] = useState(200);
  const measureRef = useRef(null);
  useEffect(() => {
    if (measureRef.current) {
      const { width } = measureRef.current.getBoundingClientRect();
      setLabelWidth(width);
    }
  }, [state]);
  return /* @__PURE__ */ jsxs11(Fragment3, { children: [
    /* @__PURE__ */ jsx16(
      "div",
      {
        ref: measureRef,
        style: {
          position: "absolute",
          visibility: "hidden",
          whiteSpace: "nowrap"
        },
        "aria-hidden": true,
        children
      }
    ),
    /* @__PURE__ */ jsx16(
      motion9.span,
      {
        layout: true,
        style: {
          position: "relative",
          whiteSpace: "nowrap",
          display: "flex",
          overflow: "hidden"
        },
        animate: { width: labelWidth },
        transition: SPRING_CONFIG,
        children: /* @__PURE__ */ jsx16(AnimatePresence5, { mode: "sync", initial: false, children: /* @__PURE__ */ jsx16(
          motion9.div,
          {
            style: { textWrap: "nowrap" },
            initial: {
              y: -20,
              opacity: OPACITY3.hidden,
              filter: "blur(10px)",
              position: "absolute"
            },
            animate: {
              y: 0,
              opacity: OPACITY3.visible,
              filter: "blur(0px)",
              position: "relative"
            },
            exit: {
              y: 20,
              opacity: OPACITY3.hidden,
              filter: "blur(10px)",
              position: "absolute"
            },
            transition: {
              duration: DURATION6.normal,
              ease: EASING4.inOut
            },
            children
          },
          state
        ) })
      }
    )
  ] });
};

// src/patterns/navigation/index.tsx
import React14 from "react";
import { Tabs } from "radix-ui";
import { AccessibleIcon } from "radix-ui";
import { motion as motion10 } from "motion/react";
import { nav } from "@pinatagrams/design-system/recipes";
import { Fragment as Fragment4, jsx as jsx17, jsxs as jsxs12 } from "react/jsx-runtime";
var Navigation = ({
  value,
  onValueChange,
  label: label2 = "Bottom navigation menu",
  children
}) => {
  const classes = nav();
  return /* @__PURE__ */ jsx17(Tabs.Root, { value, onValueChange, orientation: "vertical", asChild: true, children: /* @__PURE__ */ jsx17(
    motion10.nav,
    {
      initial: { y: 100, opacity: 0 },
      animate: { y: 0, opacity: 1 },
      exit: { y: 100, opacity: 0 },
      transition: { type: "spring", stiffness: 300, damping: 30 },
      role: "navigation",
      "aria-label": label2,
      className: classes.root,
      children
    }
  ) });
};
var NavigationTitle = ({ children }) => {
  const classes = nav();
  return /* @__PURE__ */ jsx17("div", { className: classes.title, children });
};
var NavigationList = ({ children }) => {
  const classes = nav();
  return /* @__PURE__ */ jsx17(Tabs.List, { "aria-label": "Tabs", asChild: true, children: /* @__PURE__ */ jsx17(motion10.ul, { className: classes.list, children }) });
};
var NavigationTab = ({
  value,
  icon,
  disabled = false,
  variant = "default",
  children,
  onClick,
  asChild = false
}) => {
  const [isActive, setIsActive] = React14.useState(false);
  const buttonRef = React14.useRef(null);
  const setButtonRef = React14.useCallback((node) => {
    buttonRef.current = node;
  }, []);
  const motionVariants = {
    initial: {
      opacity: 0.6
    },
    show: {
      opacity: 1
    }
  };
  React14.useEffect(() => {
    const button2 = buttonRef.current;
    if (!button2) return;
    const observer = new MutationObserver(() => {
      const active = button2.getAttribute("data-state") === "active";
      const isDisabled = button2 instanceof HTMLButtonElement ? button2.disabled : button2.getAttribute("aria-disabled") === "true";
      console.log(`[NavigationTab:${value}] data-state changed:`, {
        active,
        dataState: button2.getAttribute("data-state"),
        disabled: isDisabled
      });
      setIsActive(active);
    });
    observer.observe(button2, { attributes: true, attributeFilter: ["data-state"] });
    setIsActive(button2.getAttribute("data-state") === "active");
    return () => observer.disconnect();
  }, [value]);
  const handleClick = (e) => {
    console.log(`[NavigationTab:${value}] clicked:`, {
      disabled,
      isActive,
      variant,
      defaultPrevented: e.defaultPrevented
    });
    if (onClick && isActive && !disabled) {
      console.log(`[NavigationTab:${value}] Triggering custom onClick handler`);
      onClick(value);
    }
  };
  const content = asChild ? children : /* @__PURE__ */ jsxs12(Fragment4, { children: [
    icon && /* @__PURE__ */ jsx17(AccessibleIcon.Root, { label: typeof children === "string" ? children : "Navigation item", children: icon }),
    /* @__PURE__ */ jsx17("span", { children })
  ] });
  const classes = nav();
  return /* @__PURE__ */ jsx17(
    motion10.li,
    {
      className: classes.listItem,
      variants: motionVariants,
      initial: "initial",
      whileHover: disabled ? void 0 : "show",
      whileTap: disabled ? void 0 : "show",
      animate: isActive ? "show" : "initial",
      children: /* @__PURE__ */ jsx17(Tabs.Trigger, { value, disabled, asChild: true, children: asChild ? React14.cloneElement(children, {
        ref: setButtonRef,
        className: [
          classes.link || "",
          children.props?.className || ""
        ].filter(Boolean).join(" "),
        "data-icon": !!icon,
        "data-variant": variant,
        onClick: handleClick,
        "aria-disabled": disabled
      }) : /* @__PURE__ */ jsx17(
        motion10.button,
        {
          ref: setButtonRef,
          className: classes.link,
          "data-icon": !!icon,
          "data-variant": variant,
          onClick: handleClick,
          children: content
        }
      ) })
    }
  );
};
var NavigationFooter = ({ children }) => {
  const classes = nav();
  return /* @__PURE__ */ jsx17("footer", { className: classes.footer, children });
};
Navigation.Title = NavigationTitle;
Navigation.List = NavigationList;
Navigation.Tab = NavigationTab;
Navigation.Footer = NavigationFooter;
var navigation_default = Navigation;

// src/patterns/user-card/index.tsx
import React16, { useEffect as useEffect2, useState as useState2 } from "react";
import { motion as motion12, AnimatePresence as AnimatePresence6, useDragControls } from "motion/react";
import { rowLayout as rowLayout2, stackLayout as stackLayout2 } from "@pinatagrams/design-system/recipes";

// src/components/card/index.tsx
import React15 from "react";
import { motion as motion11 } from "motion/react";
import { DURATION as DURATION7, EASING as EASING5, OPACITY as OPACITY4, SPRING as SPRING4 } from "@pinatagrams/design-system";
import { card } from "@pinatagrams/design-system/recipes";
import { jsx as jsx18 } from "react/jsx-runtime";
var MOTION_CARD_COMPONENTS = {
  div: motion11.div,
  article: motion11.article,
  section: motion11.section,
  aside: motion11.aside
};
var MOTION_ANCHOR = motion11.a;
var Card = React15.forwardRef(
  ({
    interactive = false,
    elevation = "flat",
    variant = "default",
    as = "div",
    children,
    className,
    url
  }, ref) => {
    const classes = card({ interactive, elevation, variant }) + (className ? ` ${className}` : "");
    const Component = MOTION_CARD_COMPONENTS[as];
    const cardContent = /* @__PURE__ */ jsx18(
      Component,
      {
        ref,
        className: classes,
        initial: interactive ? "hidden" : false,
        animate: "show",
        whileHover: interactive ? "hover" : void 0,
        variants: {
          hidden: { opacity: OPACITY4.hidden, y: 8 },
          show: {
            opacity: OPACITY4.visible,
            y: 0,
            transition: { duration: DURATION7.slow, ease: EASING5.out }
          },
          hover: {
            y: -4,
            boxShadow: "var(--shadow-raised)",
            transition: SPRING4.smooth
          }
        },
        children
      }
    );
    if (url) {
      return /* @__PURE__ */ jsx18(MOTION_ANCHOR, { href: url, children: cardContent });
    }
    return cardContent;
  }
);
Card.displayName = "Card";
var card_default = Card;

// src/patterns/user-card/index.tsx
import { jsx as jsx19, jsxs as jsxs13 } from "react/jsx-runtime";
var MotionCard = motion12(Card);
var RoleBadge = ({
  role,
  userId,
  index,
  enableRoleDrag,
  roleDropTargetSelector,
  onRoleClick,
  onRoleDragStart,
  onRoleDrag,
  onRoleDragEnd
}) => {
  const dragControls = useDragControls();
  const [isDragging, setIsDragging] = useState2(false);
  const [dragOffset, setDragOffset] = useState2({ x: 0, y: 0 });
  const handleDragStart = (_event, info) => {
    if (!enableRoleDrag) return;
    setIsDragging(true);
    setDragOffset({ x: info.point.x, y: info.point.y });
    onRoleDragStart?.(role.id, info, userId);
  };
  const handleDrag = (_event, info) => {
    if (!enableRoleDrag) return;
    setDragOffset(info.offset);
    onRoleDrag?.(role.id, info, userId);
    let x = info.point.x;
    let y = info.point.y;
    if (typeof PointerEvent !== "undefined" && _event instanceof PointerEvent) {
      x = _event.clientX;
      y = _event.clientY;
    } else if (typeof TouchEvent !== "undefined" && _event instanceof TouchEvent && _event.changedTouches?.[0]) {
      x = _event.changedTouches[0].clientX;
      y = _event.changedTouches[0].clientY;
    }
    let targetId = null;
    if (typeof document !== "undefined" && typeof document.elementsFromPoint === "function") {
      const els = document.elementsFromPoint(x, y);
      for (const el of els) {
        const maybe = el.closest(roleDropTargetSelector);
        if (maybe instanceof HTMLElement && maybe.dataset?.userId) {
          targetId = maybe.dataset.userId;
          break;
        }
      }
    } else {
      const elementUnder = document.elementFromPoint(x, y);
      const dropTarget = elementUnder?.closest(roleDropTargetSelector);
      targetId = dropTarget?.dataset.userId ?? null;
    }
    if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent("fiesta:drag-over-user", { detail: { userId: targetId } })
      );
    }
  };
  const handleDragEnd = (_event, info) => {
    if (!enableRoleDrag) return;
    setIsDragging(false);
    let x = info.point.x;
    let y = info.point.y;
    if (typeof PointerEvent !== "undefined" && _event instanceof PointerEvent) {
      x = _event.clientX;
      y = _event.clientY;
    } else if (typeof TouchEvent !== "undefined" && _event instanceof TouchEvent && _event.changedTouches?.[0]) {
      x = _event.changedTouches[0].clientX;
      y = _event.changedTouches[0].clientY;
    }
    let targetUserId = null;
    if (typeof document !== "undefined" && typeof document.elementsFromPoint === "function") {
      const els = document.elementsFromPoint(x, y);
      for (const el of els) {
        const maybe = el.closest(roleDropTargetSelector);
        if (maybe instanceof HTMLElement && maybe.dataset?.userId) {
          targetUserId = maybe.dataset.userId;
          break;
        }
      }
    } else {
      const el = document.elementFromPoint(x, y);
      const maybe = el?.closest(roleDropTargetSelector);
      targetUserId = maybe?.dataset.userId ?? null;
    }
    onRoleDragEnd?.(role.id, info, userId, targetUserId);
    setDragOffset({ x: 0, y: 0 });
  };
  const rotation = enableRoleDrag && isDragging ? Math.min(Math.max(dragOffset.x * 0.015, -2), 2) : 0;
  return /* @__PURE__ */ jsx19(
    motion12.div,
    {
      style: {
        display: "inline-block",
        touchAction: "none",
        position: "relative",
        isolation: "isolate"
      },
      children: /* @__PURE__ */ jsx19(
        motion12.div,
        {
          drag: enableRoleDrag,
          dragControls,
          dragListener: false,
          dragSnapToOrigin: true,
          dragElastic: 0.1,
          whileDrag: {
            scale: 1.05,
            zIndex: 3e3,
            position: "relative",
            boxShadow: "var(--shadows-drag, 0 12px 28px rgba(0,0,0,0.2))",
            pointerEvents: "none"
          },
          dragTransition: { bounceStiffness: 600, bounceDamping: 15 },
          layout: true,
          initial: { opacity: 0, scale: 0.8 },
          animate: {
            opacity: isDragging ? 0.9 : 1,
            scale: 1,
            rotate: rotation,
            cursor: enableRoleDrag ? isDragging ? "grabbing" : "grab" : "pointer",
            zIndex: isDragging ? 2 : 1
          },
          exit: { opacity: 0, scale: 0.8 },
          transition: {
            duration: 0.2,
            delay: index * 0.02,
            layout: { duration: 0.3 },
            rotate: { type: "spring", stiffness: 300, damping: 30 }
          },
          onDragStart: handleDragStart,
          onDrag: handleDrag,
          onDragEnd: handleDragEnd,
          onPointerDown: enableRoleDrag ? (event) => dragControls.start(event) : void 0,
          onClick: () => {
            if (!isDragging) onRoleClick?.(role.id);
          },
          children: /* @__PURE__ */ jsxs13(badge_default, { color: role.color, children: [
            role.label,
            onRoleClick && /* @__PURE__ */ jsx19("span", { "aria-hidden": "true", children: "\xD7" })
          ] })
        }
      )
    }
  );
};
var UserCard = React16.forwardRef(
  ({
    userId,
    name,
    subtitle,
    metadata,
    roles,
    emptyRolesText = "No roles assigned",
    isDragOver = false,
    onRoleClick,
    enableRoleDrag = true,
    roleDropTargetSelector = "[data-user-id]",
    onRoleDragStart,
    onRoleDrag,
    onRoleDragEnd,
    animationDelay = 0
  }, ref) => {
    const [externalOver, setExternalOver] = useState2(false);
    useEffect2(() => {
      const overHandler = (e) => {
        const anyEvent = e;
        const target = anyEvent.detail?.userId ?? null;
        setExternalOver(target === userId);
      };
      window.addEventListener("fiesta:drag-over-user", overHandler);
      return () => {
        window.removeEventListener("fiesta:drag-over-user", overHandler);
      };
    }, [userId]);
    const isBeingDraggedOver = isDragOver || externalOver;
    return /* @__PURE__ */ jsxs13(
      MotionCard,
      {
        ref,
        "data-user-id": userId,
        as: "article",
        layout: true,
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -20 },
        transition: { duration: 0.3, delay: animationDelay, layout: { duration: 0.4 } },
        style: { position: "relative" },
        variant: isBeingDraggedOver ? "ghost" : "default",
        elevation: isBeingDraggedOver ? "depressed" : "flat",
        interactive: true,
        "aria-label": `User card for ${name}`,
        children: [
          /* @__PURE__ */ jsxs13("header", { className: rowLayout2({ justify: "between", align: "start" }).root, children: [
            /* @__PURE__ */ jsxs13("div", { className: stackLayout2({ gap: "xs" }).root, children: [
              /* @__PURE__ */ jsx19(Body, { children: name }),
              subtitle && /* @__PURE__ */ jsx19(Supplemental, { emphasis: "muted", children: subtitle })
            ] }),
            metadata && /* @__PURE__ */ jsx19(Supplemental, { emphasis: "muted", children: metadata })
          ] }),
          /* @__PURE__ */ jsx19(motion12.div, { layout: true, className: rowLayout2({ gap: "sm" }).root, children: /* @__PURE__ */ jsx19(AnimatePresence6, { children: roles.length === 0 ? /* @__PURE__ */ jsx19(
            motion12.div,
            {
              initial: { opacity: 0 },
              animate: { opacity: 1 },
              exit: { opacity: 0 },
              transition: { duration: 0.2 },
              children: /* @__PURE__ */ jsx19(Supplemental, { emphasis: "muted", children: emptyRolesText })
            }
          ) : roles.map((role, index) => /* @__PURE__ */ jsx19(
            RoleBadge,
            {
              role,
              userId,
              index,
              enableRoleDrag,
              roleDropTargetSelector,
              onRoleClick,
              onRoleDragStart,
              onRoleDrag,
              onRoleDragEnd
            },
            role.id
          )) }) })
        ]
      }
    );
  }
);
UserCard.displayName = "UserCard";
var user_card_default = UserCard;

// src/patterns/workflow-card/index.tsx
import { motion as motion13 } from "motion/react";
import { rowLayout as rowLayout3, stackLayout as stackLayout3 } from "@pinatagrams/design-system/recipes";
import { jsx as jsx20, jsxs as jsxs14 } from "react/jsx-runtime";
var statusToBadgeColor = (status2) => {
  switch (status2) {
    case "completed":
      return "success";
    case "running":
      return "info";
    case "pending":
      return "warning";
    case "failed":
      return "error";
    case "cancelled":
      return "warning";
    default:
      return "info";
  }
};
var WorkflowCard = ({
  name,
  status: status2,
  updatedAt,
  isExpanded = false,
  onToggle,
  children
}) => {
  return /* @__PURE__ */ jsxs14(
    Card,
    {
      as: "article",
      interactive: !!onToggle,
      onClick: onToggle,
      "aria-expanded": isExpanded,
      "aria-label": `Workflow: ${name}, Status: ${status2}`,
      children: [
        /* @__PURE__ */ jsxs14("header", { className: rowLayout3({ justify: "between" }).root, children: [
          /* @__PURE__ */ jsxs14("div", { className: rowLayout3({ gap: "sm" }).root, children: [
            /* @__PURE__ */ jsx20(Body, { children: name }),
            /* @__PURE__ */ jsx20(badge_default, { color: statusToBadgeColor(status2), children: status2 })
          ] }),
          /* @__PURE__ */ jsx20(Supplemental, { emphasis: "muted", children: updatedAt })
        ] }),
        isExpanded && children && /* @__PURE__ */ jsx20(
          motion13.div,
          {
            initial: { opacity: 0, height: 0 },
            animate: { opacity: 1, height: "auto" },
            exit: { opacity: 0, height: 0 },
            transition: { duration: 0.2 },
            children
          }
        )
      ]
    }
  );
};
var WorkflowDetailItem = ({ label: label2, value }) => /* @__PURE__ */ jsxs14("div", { className: stackLayout3({ gap: "xs" }).root, children: [
  /* @__PURE__ */ jsx20(Supplemental, { emphasis: "muted", children: label2 }),
  /* @__PURE__ */ jsx20(Supplemental, { children: value })
] });
var WorkflowDataBlock = ({ data }) => /* @__PURE__ */ jsxs14("div", { className: stackLayout3({ gap: "xs" }).root, children: [
  /* @__PURE__ */ jsx20(Supplemental, { emphasis: "muted", children: "Data" }),
  /* @__PURE__ */ jsx20("pre", { children: /* @__PURE__ */ jsx20("code", { children: JSON.stringify(data, null, 2) }) })
] });
var workflow_card_default = WorkflowCard;

// src/patterns/fulfillment-batch-card/index.tsx
import { fulfillmentBatchCard } from "@pinatagrams/design-system/recipes";

// src/components/indicator/index.tsx
import { CircleIcon } from "@phosphor-icons/react";

// src/components/icon/index.tsx
import { AccessibleIcon as AccessibleIcon2 } from "radix-ui";
import { jsx as jsx21 } from "react/jsx-runtime";
var Icon2 = ({
  label: label2,
  icon: IconComponent,
  ...props
}) => {
  return /* @__PURE__ */ jsx21(AccessibleIcon2.Root, { label: label2, children: /* @__PURE__ */ jsx21(IconComponent, { ...props }) });
};
Icon2.displayName = "Icon";
var icon_default = Icon2;

// src/components/dropdown-menu/index.tsx
import React17, { useCallback as useCallback3 } from "react";
import { DropdownMenu as DM } from "radix-ui";
import { AnimatePresence as AnimatePresence7, motion as motion14, useMotionValue, useTransform as useTransform2 } from "motion/react";
import { DURATION as DURATION8, EASING as EASING6, SPRING as SPRING5 } from "@pinatagrams/design-system";
import { dropdownMenuContent } from "@pinatagrams/design-system/recipes";
import { Fragment as Fragment5, jsx as jsx22, jsxs as jsxs15 } from "react/jsx-runtime";
var DropdownMenu = ({
  trigger,
  children,
  open,
  onOpenChange,
  overlay = false,
  ...contentProps
}) => {
  const [isOpen, setIsOpen] = React17.useState(open ?? false);
  const targetLayer = overlay ? 4 /* Overlay */ : 2 /* Popover */;
  const container = useLayerContainer(targetLayer);
  const menuRef = React17.useRef(null);
  const [pos, setPos] = React17.useState(void 0);
  React17.useEffect(() => {
    if (open !== void 0) {
      setIsOpen(open);
    }
  }, [open]);
  const handleOnPlaced = useCallback3(() => {
    if (menuRef.current) {
      const rect = menuRef.current.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      setPos({ x: centerX, y: centerY });
    } else if (!isOpen) {
    }
  }, [menuRef, isOpen]);
  const handleOpenChange = (newOpen) => {
    setIsOpen(newOpen);
    onOpenChange?.(newOpen);
  };
  return /* @__PURE__ */ jsxs15(DM.Root, { open: isOpen, onOpenChange: handleOpenChange, children: [
    /* @__PURE__ */ jsx22(DM.Trigger, { asChild: true, children: trigger }),
    /* @__PURE__ */ jsx22(AnimatePresence7, { children: isOpen && /* @__PURE__ */ jsx22(DM.Portal, { container, forceMount: true, children: /* @__PURE__ */ jsxs15(Fragment5, { children: [
      overlay && pos && /* @__PURE__ */ jsx22(Overlay, { status: "info", origin: pos }, "overlay"),
      /* @__PURE__ */ jsx22(
        DM.Content,
        {
          sideOffset: 2,
          ...contentProps,
          forceMount: true,
          onPlaced: handleOnPlaced,
          children: /* @__PURE__ */ jsxs15(
            motion14.article,
            {
              className: dropdownMenuContent({}).content,
              initial: { opacity: 0, scale: 0.95 },
              animate: { opacity: 1, scale: 1 },
              exit: { opacity: 0, scale: 0.95 },
              transition: { duration: 0.15 },
              ref: menuRef,
              children: [
                children,
                /* @__PURE__ */ jsx22(DM.Arrow, { className: dropdownMenuContent({}).arrow, width: "1em", height: ".5em" })
              ]
            }
          )
        }
      )
    ] }) }) })
  ] });
};
var DropdownRadioGroup = ({
  header,
  value,
  onChange,
  items,
  placeholder = "No options"
}) => {
  const hasItems = items.length > 0;
  const scale = useMotionValue(1);
  const borderWidth = useTransform2(scale, [0.95, 1.05], [3, 1.5]);
  return /* @__PURE__ */ jsxs15(Fragment5, { children: [
    header && /* @__PURE__ */ jsx22(DM.Label, { className: dropdownMenuContent({}).label, children: header }),
    hasItems ? /* @__PURE__ */ jsx22(DM.RadioGroup, { value, onValueChange: onChange, asChild: true, children: /* @__PURE__ */ jsx22(motion14.ol, { className: dropdownMenuContent({}).item, children: items.map((item) => /* @__PURE__ */ jsx22(
      DM.RadioItem,
      {
        value: item.value,
        disabled: item.disabled,
        textValue: item.label,
        asChild: true,
        children: /* @__PURE__ */ jsxs15(button_default, { children: [
          /* @__PURE__ */ jsx22(AnimatePresence7, { children: value === item.value && /* @__PURE__ */ jsx22(DM.ItemIndicator, { asChild: true, forceMount: true, children: /* @__PURE__ */ jsxs15("div", { className: dropdownMenuContent({}).indicator, children: [
            /* @__PURE__ */ jsx22(
              motion14.div,
              {
                className: dropdownMenuContent({}).indicatorBorder,
                style: { borderWidth },
                initial: false,
                animate: {
                  borderColor: "#ffff",
                  scale: 1
                },
                exit: {
                  borderColor: "#fff0",
                  scale: 0.95
                },
                transition: {
                  duration: DURATION8.normal,
                  ease: EASING6.out
                }
              }
            ),
            /* @__PURE__ */ jsx22(
              motion14.div,
              {
                className: dropdownMenuContent({}).indicatorDot,
                initial: { scale: 0 },
                animate: {
                  scale: 1,
                  opacity: 1
                },
                exit: {
                  scale: 0,
                  opacity: 0
                },
                transition: SPRING5.bouncy
              }
            )
          ] }) }) }),
          item.label,
          item.shortcut && /* @__PURE__ */ jsx22("span", { style: { marginLeft: "auto", opacity: 0.5, fontSize: "0.875em" }, children: item.shortcut })
        ] })
      },
      item.value
    )) }) }) : /* @__PURE__ */ jsx22(DM.Item, { className: dropdownMenuContent({}).item, disabled: true, children: placeholder })
  ] });
};
var DropdownMenuRadioItem = ({ children, ...props }) => {
  return /* @__PURE__ */ jsxs15(DM.RadioItem, { className: dropdownMenuContent({}).item, ...props, children: [
    /* @__PURE__ */ jsx22(DM.ItemIndicator, { className: dropdownMenuContent({}).indicator, children: /* @__PURE__ */ jsx22("span", { children: "\u2713" }) }),
    children
  ] });
};
var Dropdown = Object.assign(DropdownMenu, {
  RadioGroup: DropdownRadioGroup
});
DropdownMenu.displayName = "DropdownMenu";
DropdownRadioGroup.displayName = "DropdownRadioGroup";
DropdownMenuRadioItem.displayName = "DropdownMenuRadioItem";
var dropdown_menu_default = Dropdown;

// src/components/indicator/index.tsx
import { indicator } from "@pinatagrams/design-system/recipes";
import { jsx as jsx23, jsxs as jsxs16 } from "react/jsx-runtime";
var Indicator = ({
  label: label2,
  status: status2 = "unavailable",
  icon,
  dropdown,
  overlay,
  ariaLabel
}) => {
  const iconLabel = label2 ?? ariaLabel ?? "Status";
  const iconElement = /* @__PURE__ */ jsx23("button", { className: indicator({ status: status2 }), children: /* @__PURE__ */ jsx23(icon_default, { label: iconLabel, icon: icon || CircleIcon, color: "currentColor", weight: "fill" }) });
  if (dropdown) {
    return /* @__PURE__ */ jsx23(dropdown_menu_default, { overlay, trigger: iconElement, children: dropdown });
  }
  return /* @__PURE__ */ jsxs16(tooltip_default, { children: [
    /* @__PURE__ */ jsx23(tooltip_default.Trigger, { children: iconElement }),
    /* @__PURE__ */ jsx23(tooltip_default.Content, { children: label2 })
  ] });
};
Indicator.displayName = "Indicator";
var indicator_default = Indicator;

// src/patterns/fulfillment-batch-card/index.tsx
import { jsx as jsx24, jsxs as jsxs17 } from "react/jsx-runtime";
var status = {
  unfulfilled: "unavailable",
  "labels printed": "inprogress",
  "shipping labels printed": "inprogress",
  completed: "latest"
};
function FulfillmentBatchCard({ batch, url, ...props }) {
  const { root, stat } = fulfillmentBatchCard();
  return /* @__PURE__ */ jsx24(Stack, { children: /* @__PURE__ */ jsxs17(card_default, { as: "article", className: root, interactive: true, url, ...props, children: [
    /* @__PURE__ */ jsxs17("header", { children: [
      /* @__PURE__ */ jsx24("h2", { children: batch.label }),
      /* @__PURE__ */ jsx24(indicator_default, { status: status[batch.fulfillmentStatus], label: batch.fulfillmentStatus })
    ] }),
    /* @__PURE__ */ jsxs17(Inline, { align: "center", gap: "lg", children: [
      /* @__PURE__ */ jsxs17(Stack, { align: "center", gap: "sm", children: [
        /* @__PURE__ */ jsx24(Title, { emphasis: "muted", children: "Orders" }),
        /* @__PURE__ */ jsx24("h2", { className: stat, children: batch.orderCount })
      ] }),
      /* @__PURE__ */ jsxs17(Stack, { align: "center", gap: "sm", children: [
        /* @__PURE__ */ jsx24(Title, { hierarchy: "subtitle", emphasis: "muted", children: "Labels" }),
        /* @__PURE__ */ jsx24("h2", { className: stat, children: batch.labelCount })
      ] })
    ] })
  ] }) });
}
var fulfillment_batch_card_default = FulfillmentBatchCard;

// src/patterns/draggable-badge/index.tsx
import { useEffect as useEffect3, useState as useState3 } from "react";
import { motion as motion15, useDragControls as useDragControls2 } from "motion/react";
import { DURATION as DURATION9, MOTION_VALUES, OPACITY as OPACITY5, SCALE as SCALE3, SPRING as SPRING6 } from "@pinatagrams/design-system";
import { jsx as jsx25, jsxs as jsxs18 } from "react/jsx-runtime";
var MotionBadge = motion15(badge_default);
var DraggableBadge = ({
  id,
  label: label2,
  color,
  isDragging: externalIsDragging,
  onDragStart,
  onDrag,
  onDragEnd,
  dropTargetSelector = "[data-user-id]",
  icon
}) => {
  const dragControls = useDragControls2();
  const [isDragging, setIsDragging] = useState3(false);
  const [dragOffset, setDragOffset] = useState3({ x: 0, y: 0 });
  const isCurrentlyDragging = Boolean(externalIsDragging ?? isDragging);
  useEffect3(() => {
    if (externalIsDragging === false) {
      setIsDragging(false);
    }
  }, [externalIsDragging]);
  const handleDragStart = (_event, info) => {
    setIsDragging(true);
    setDragOffset({ x: info.point.x, y: info.point.y });
    onDragStart?.(id, info);
  };
  const handleDrag = (_event, info) => {
    setDragOffset(info.offset);
    onDrag?.(id, info);
    let x = info.point.x;
    let y = info.point.y;
    if (typeof PointerEvent !== "undefined" && _event instanceof PointerEvent) {
      x = _event.clientX;
      y = _event.clientY;
    } else if (typeof TouchEvent !== "undefined" && _event instanceof TouchEvent && _event.changedTouches?.[0]) {
      x = _event.changedTouches[0].clientX;
      y = _event.changedTouches[0].clientY;
    }
    let targetId = null;
    if (typeof document !== "undefined" && typeof document.elementsFromPoint === "function") {
      const els = document.elementsFromPoint(x, y);
      for (const el of els) {
        const maybe = el.closest(dropTargetSelector);
        if (maybe instanceof HTMLElement && maybe.dataset?.userId) {
          targetId = maybe.dataset.userId;
          break;
        }
      }
    } else {
      const elementUnder = document.elementFromPoint(x, y);
      const dropTarget = elementUnder?.closest(dropTargetSelector);
      if (dropTarget instanceof HTMLElement) {
        targetId = dropTarget.dataset.userId ?? null;
      }
    }
    if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent("fiesta:drag-over-user", { detail: { userId: targetId } })
      );
      window.dispatchEvent(new CustomEvent("fiesta:drag-pointer", { detail: { x, y } }));
    }
  };
  const handleDragEnd = (_event, info) => {
    setIsDragging(false);
    let x = info.point.x;
    let y = info.point.y;
    if (typeof PointerEvent !== "undefined" && _event instanceof PointerEvent) {
      x = _event.clientX;
      y = _event.clientY;
    } else if (typeof TouchEvent !== "undefined" && _event instanceof TouchEvent && _event.changedTouches?.[0]) {
      x = _event.changedTouches[0].clientX;
      y = _event.changedTouches[0].clientY;
    }
    let targetId = null;
    if (typeof document !== "undefined" && typeof document.elementsFromPoint === "function") {
      const els = document.elementsFromPoint(x, y);
      for (const el of els) {
        const maybe = el.closest(dropTargetSelector);
        if (maybe instanceof HTMLElement && maybe.dataset?.userId) {
          targetId = maybe.dataset.userId;
          break;
        }
      }
    } else {
      const elementUnder = document.elementFromPoint(x, y);
      const dropTarget = elementUnder?.closest(dropTargetSelector);
      if (dropTarget instanceof HTMLElement) {
        targetId = dropTarget.dataset.userId ?? null;
      }
    }
    onDragEnd?.(id, info, targetId);
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("fiesta:drag-over-user", { detail: { userId: null } }));
      window.dispatchEvent(
        new CustomEvent("fiesta:drag-pointer", { detail: { x: null, y: null } })
      );
    }
    setDragOffset({ x: 0, y: 0 });
  };
  const rotation = isCurrentlyDragging ? Math.min(Math.max(dragOffset.x * 0.015, -2), 2) : 0;
  return /* @__PURE__ */ jsxs18(
    MotionBadge,
    {
      color,
      drag: true,
      dragControls,
      dragListener: false,
      dragSnapToOrigin: true,
      dragElastic: 0.1,
      whileDrag: {
        scale: SCALE3.subtleUp,
        boxShadow: "var(--shadows-drag, 0 12px 28px rgba(0,0,0,0.2))",
        pointerEvents: "none"
      },
      dragTransition: {
        bounceStiffness: MOTION_VALUES.spring.softBounce.stiffness,
        bounceDamping: MOTION_VALUES.spring.softBounce.damping
      },
      animate: {
        rotate: rotation,
        opacity: isCurrentlyDragging ? OPACITY5.dragging : OPACITY5.visible,
        cursor: isDragging ? "grabbing" : "grab"
      },
      transition: {
        duration: DURATION9.normal,
        rotate: SPRING6.snappy
      },
      onDragStart: handleDragStart,
      onDrag: handleDrag,
      onDragEnd: handleDragEnd,
      onPointerDown: (event) => {
        dragControls.start(event);
      },
      children: [
        icon,
        /* @__PURE__ */ jsx25("span", { children: label2 })
      ]
    }
  );
};
var draggable_badge_default = DraggableBadge;

// src/patterns/profile-header/index.tsx
import React19 from "react";
import { rowLayout as rowLayout4, stackLayout as stackLayout4 } from "@pinatagrams/design-system/recipes";
import { jsx as jsx26, jsxs as jsxs19 } from "react/jsx-runtime";
var ProfileHeader = React19.forwardRef(
  ({ name, subtitle, avatar, children }, ref) => {
    return /* @__PURE__ */ jsxs19("header", { ref, className: rowLayout4({ gap: "md", align: "center" }).root, children: [
      avatar && /* @__PURE__ */ jsx26("figure", { "aria-hidden": "true", children: avatar }),
      /* @__PURE__ */ jsxs19("hgroup", { className: stackLayout4({ gap: "xs" }).root, children: [
        /* @__PURE__ */ jsx26(Title, { hierarchy: "subtitle", children: name }),
        subtitle && /* @__PURE__ */ jsx26(Body, { emphasis: "muted", children: subtitle })
      ] }),
      children
    ] });
  }
);
ProfileHeader.displayName = "ProfileHeader";
var profile_header_default = ProfileHeader;
export {
  AlertDialog,
  badge_default as Badge,
  banner_default as Banner,
  Body,
  Button,
  Dialog,
  FeedbackEventProvider,
  FeedbackEventRenderer,
  FiestaProvider,
  label_default as Label,
  layer_context_default as Layer,
  LayerType,
  FeedbackEventProvider as OutcomeProvider,
  OutcomeRenderer,
  Supplemental,
  Title,
  toast_default as Toast,
  ToastProvider,
  tooltip_default as Tooltip,
  TooltipProvider,
  getFeedbackEventStatus,
  getFeedbackEventStatus as getOutcomeStatus,
  patterns_exports as patterns,
  useFeedbackEvent,
  useFeedbackStore,
  useLayer,
  useLayerContainer,
  useFeedbackEvent as useOutcome
};
//# sourceMappingURL=index.js.map